var Kt = Object.defineProperty;
var Vt = (e, t, r) => t in e ? Kt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var B = (e, t, r) => (Vt(e, typeof t != "symbol" ? t + "" : t, r), r);
import { format as Xt } from "date-fns";
var St = /* @__PURE__ */ ((e) => (e.BatchManager = "batch_manager", e.BatchJobManager = "batch_job_manager", e.MessagingManager = "messaging_manager", e.IotManager = "iot_manager", e.QueuesManager = "queues_manager", e.UserManager = "users_manager", e.UserRoleManager = "users_role_manager", e.InternalUserManager = "internal_users_manager", e.B2CImpersonator = "b2c_impersonator", e.PriceManager = "price_manager", e.RoleManager = "role_manager", e.FormsManager = "forms_manager", e.SimulationManager = "simulation_manager", e.TextMiningManager = "textmining_manager", e.ServiceDeskManager = "service_desk_manager", e.RetentionManager = "retention_manager", e.RetentionConfigManager = "retention_config_manager", e.EngieAppManager = "engie_app_manager", e.EngieAppManagerAdmin = "engie_app_admin_manager", e.EvManager = "ev_manager", e.FeatureFlagManager = "feature_flags_manager", e))(St || {});
const Gt = {
  batch_manager: "Allow to manage batches",
  batch_job_manager: "Allow to manage batch jobs",
  messaging_manager: "Allow to manage email and sms configurations",
  iot_manager: "Allow to manage IOT configurations",
  textmining_manager: "Allow to manage Text Mining configurations",
  queues_manager: "Allow to manage queues",
  users_manager: "Allow to manage users",
  users_role_manager: "Allow to assign roles to users",
  internal_users_manager: "Allow to manage internal users",
  b2c_impersonator: "Allow to impersonate B2C users",
  price_manager: "Allow to upload price fiches",
  role_manager: "Allow to manage roles",
  forms_manager: "Allow to manage dynamic forms",
  simulation_manager: "Allow to run simulations",
  retention_manager: "Allow to manage customer retention",
  retention_config_manager: "Allow to manage customer retention configurations",
  engie_app_manager: "Self service for engie app management",
  engie_app_admin_manager: "Advanced feature of the engie app management",
  service_desk_manager: "Allow to configure the service desk tickets configuration",
  ev_manager: "Management of EV related data and configuration"
};
var Yt = /* @__PURE__ */ ((e) => (e.BE_MS_Customers = "be_customers", e.BE_MS_Partners = "partners", e.BE_MS_Internal_Users = "internals", e))(Yt || {}), Qt = /* @__PURE__ */ ((e) => (e.EN = "EN", e.NL = "NL", e.FR = "FR", e))(Qt || {}), Zt = /* @__PURE__ */ ((e) => (e.NL = "NL", e.FR = "FR", e.EN = "EN", e.DE = "DE", e))(Zt || {});
function _i(e, t) {
  if (e.response)
    switch (e.response.status) {
      case 400:
        if (e.response.data && typeof e.response.data.message == "string") {
          const r = e.response.data.message.match(/.+"(.+)"$/);
          return r[1] && r[1].length > 0 ? r[1] : r[0];
        }
        break;
      case 403:
        if (e.response.data && typeof e.response.data.message == "string")
          return e.response.data.message;
        break;
      case 409:
        return "This entry already exists.";
    }
  return t || e.message;
}
function mi(e) {
  return e.response.data.detail;
}
function er(e) {
  return typeof e == "object" && e.constructor === Object;
}
function We(e) {
  if (typeof e != "object" || e === null)
    return e;
  let t, r;
  if (e instanceof Date)
    return new Date(e);
  if (er(e)) {
    t = {};
    for (r in e)
      e.hasOwnProperty(r) && (t[r] = We(e[r]));
    return t;
  } else if (Array.isArray(e)) {
    t = [];
    for (let s = 0, i = e.length; s < i; s++)
      t[s] = We(e[s]);
    return t;
  }
  return e;
}
function wi(e, t = []) {
  return t.length === 0 || t.some((r) => e.includes(r));
}
function vi(e, t = []) {
  return t.length === 0 || t.every((r) => e.includes(r));
}
function tr() {
  return Object.values(St).map((e) => ({
    type: e,
    label: e,
    description: Gt[e] || ""
  }));
}
const Si = tr();
function rr(e, t) {
  const r = [];
  for (let s = 0; s <= e.length; ++s) {
    let i = s;
    for (let n = 0; n <= t.length; ++n)
      if (s === 0)
        r[n] = n;
      else if (n > 0) {
        let o = r[n - 1];
        e.charAt(s - 1) !== t.charAt(n - 1) && (o = Math.min(Math.min(o, i), r[n]) + 1), r[n - 1] = i, i = o;
      }
    s > 0 && (r[t.length] = i);
  }
  return r[t.length];
}
function sr(e, t) {
  let r = e, s = t;
  e.length < t.length && (r = t, s = e);
  const i = r.length;
  return i === 0 ? 1 : (i - rr(r, s)) / i;
}
function yi(e, t, r = !0) {
  return e = e.toLowerCase(), t = t.toLowerCase(), e === t ? 1 : e.includes(t) ? 0.99 : t.includes(e) ? 0.98 : r ? sr(e, t) : 0;
}
function bi(e) {
  return Date.UTC(
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate(),
    e.getUTCHours(),
    e.getUTCMinutes(),
    e.getUTCSeconds()
  );
}
function ki(e) {
  return e ? Xt(e, "YYYY-MM-DD") : void 0;
}
class ir {
  get(t) {
    return window.env[t];
  }
}
const Ei = new ir();
var nr = /* @__PURE__ */ ((e) => (e.ASC = "ASC", e.DESC = "DESC", e))(nr || {});
function Ci(e) {
  const t = {};
  return e && (e.pageSize && (t.size = e.pageSize), e.pageNumber && (t.page = e.pageNumber), e.sort && (t.sort = `${e.sort.field},${e.sort.direction.toString()}`)), t;
}
var F = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Y(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function or(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function s() {
      return this instanceof s ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(s) {
    var i = Object.getOwnPropertyDescriptor(e, s);
    Object.defineProperty(r, s, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[s];
      }
    });
  }), r;
}
function ar(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var yt = { exports: {} };
const cr = {}, ur = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cr
}, Symbol.toStringTag, { value: "Module" })), lr = /* @__PURE__ */ or(ur);
(function(e, t) {
  (function(r, s) {
    e.exports = s();
  })(F, function() {
    var r = r || function(s, i) {
      var n;
      if (typeof window < "u" && window.crypto && (n = window.crypto), typeof self < "u" && self.crypto && (n = self.crypto), typeof globalThis < "u" && globalThis.crypto && (n = globalThis.crypto), !n && typeof window < "u" && window.msCrypto && (n = window.msCrypto), !n && typeof F < "u" && F.crypto && (n = F.crypto), !n && typeof ar == "function")
        try {
          n = lr;
        } catch {
        }
      var o = function() {
        if (n) {
          if (typeof n.getRandomValues == "function")
            try {
              return n.getRandomValues(new Uint32Array(1))[0];
            } catch {
            }
          if (typeof n.randomBytes == "function")
            try {
              return n.randomBytes(4).readInt32LE();
            } catch {
            }
        }
        throw new Error("Native crypto module could not be used to get secure random number.");
      }, a = Object.create || function() {
        function l() {
        }
        return function(f) {
          var w;
          return l.prototype = f, w = new l(), l.prototype = null, w;
        };
      }(), c = {}, u = c.lib = {}, _ = u.Base = function() {
        return {
          /**
           * Creates a new object that inherits from this object.
           *
           * @param {Object} overrides Properties to copy into the new object.
           *
           * @return {Object} The new object.
           *
           * @static
           *
           * @example
           *
           *     var MyType = CryptoJS.lib.Base.extend({
           *         field: 'value',
           *
           *         method: function () {
           *         }
           *     });
           */
          extend: function(l) {
            var f = a(this);
            return l && f.mixIn(l), (!f.hasOwnProperty("init") || this.init === f.init) && (f.init = function() {
              f.$super.init.apply(this, arguments);
            }), f.init.prototype = f, f.$super = this, f;
          },
          /**
           * Extends this object and runs the init method.
           * Arguments to create() will be passed to init().
           *
           * @return {Object} The new object.
           *
           * @static
           *
           * @example
           *
           *     var instance = MyType.create();
           */
          create: function() {
            var l = this.extend();
            return l.init.apply(l, arguments), l;
          },
          /**
           * Initializes a newly created object.
           * Override this method to add some logic when your objects are created.
           *
           * @example
           *
           *     var MyType = CryptoJS.lib.Base.extend({
           *         init: function () {
           *             // ...
           *         }
           *     });
           */
          init: function() {
          },
          /**
           * Copies properties into this object.
           *
           * @param {Object} properties The properties to mix in.
           *
           * @example
           *
           *     MyType.mixIn({
           *         field: 'value'
           *     });
           */
          mixIn: function(l) {
            for (var f in l)
              l.hasOwnProperty(f) && (this[f] = l[f]);
            l.hasOwnProperty("toString") && (this.toString = l.toString);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = instance.clone();
           */
          clone: function() {
            return this.init.prototype.extend(this);
          }
        };
      }(), g = u.WordArray = _.extend({
        /**
         * Initializes a newly created word array.
         *
         * @param {Array} words (Optional) An array of 32-bit words.
         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
         *
         * @example
         *
         *     var wordArray = CryptoJS.lib.WordArray.create();
         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
         */
        init: function(l, f) {
          l = this.words = l || [], f != i ? this.sigBytes = f : this.sigBytes = l.length * 4;
        },
        /**
         * Converts this word array to a string.
         *
         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
         *
         * @return {string} The stringified word array.
         *
         * @example
         *
         *     var string = wordArray + '';
         *     var string = wordArray.toString();
         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
         */
        toString: function(l) {
          return (l || h).stringify(this);
        },
        /**
         * Concatenates a word array to this word array.
         *
         * @param {WordArray} wordArray The word array to append.
         *
         * @return {WordArray} This word array.
         *
         * @example
         *
         *     wordArray1.concat(wordArray2);
         */
        concat: function(l) {
          var f = this.words, w = l.words, S = this.sigBytes, y = l.sigBytes;
          if (this.clamp(), S % 4)
            for (var b = 0; b < y; b++) {
              var C = w[b >>> 2] >>> 24 - b % 4 * 8 & 255;
              f[S + b >>> 2] |= C << 24 - (S + b) % 4 * 8;
            }
          else
            for (var x = 0; x < y; x += 4)
              f[S + x >>> 2] = w[x >>> 2];
          return this.sigBytes += y, this;
        },
        /**
         * Removes insignificant bits.
         *
         * @example
         *
         *     wordArray.clamp();
         */
        clamp: function() {
          var l = this.words, f = this.sigBytes;
          l[f >>> 2] &= 4294967295 << 32 - f % 4 * 8, l.length = s.ceil(f / 4);
        },
        /**
         * Creates a copy of this word array.
         *
         * @return {WordArray} The clone.
         *
         * @example
         *
         *     var clone = wordArray.clone();
         */
        clone: function() {
          var l = _.clone.call(this);
          return l.words = this.words.slice(0), l;
        },
        /**
         * Creates a word array filled with random bytes.
         *
         * @param {number} nBytes The number of random bytes to generate.
         *
         * @return {WordArray} The random word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.lib.WordArray.random(16);
         */
        random: function(l) {
          for (var f = [], w = 0; w < l; w += 4)
            f.push(o());
          return new g.init(f, l);
        }
      }), p = c.enc = {}, h = p.Hex = {
        /**
         * Converts a word array to a hex string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The hex string.
         *
         * @static
         *
         * @example
         *
         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
         */
        stringify: function(l) {
          for (var f = l.words, w = l.sigBytes, S = [], y = 0; y < w; y++) {
            var b = f[y >>> 2] >>> 24 - y % 4 * 8 & 255;
            S.push((b >>> 4).toString(16)), S.push((b & 15).toString(16));
          }
          return S.join("");
        },
        /**
         * Converts a hex string to a word array.
         *
         * @param {string} hexStr The hex string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
         */
        parse: function(l) {
          for (var f = l.length, w = [], S = 0; S < f; S += 2)
            w[S >>> 3] |= parseInt(l.substr(S, 2), 16) << 24 - S % 8 * 4;
          return new g.init(w, f / 2);
        }
      }, E = p.Latin1 = {
        /**
         * Converts a word array to a Latin1 string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The Latin1 string.
         *
         * @static
         *
         * @example
         *
         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
         */
        stringify: function(l) {
          for (var f = l.words, w = l.sigBytes, S = [], y = 0; y < w; y++) {
            var b = f[y >>> 2] >>> 24 - y % 4 * 8 & 255;
            S.push(String.fromCharCode(b));
          }
          return S.join("");
        },
        /**
         * Converts a Latin1 string to a word array.
         *
         * @param {string} latin1Str The Latin1 string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
         */
        parse: function(l) {
          for (var f = l.length, w = [], S = 0; S < f; S++)
            w[S >>> 2] |= (l.charCodeAt(S) & 255) << 24 - S % 4 * 8;
          return new g.init(w, f);
        }
      }, m = p.Utf8 = {
        /**
         * Converts a word array to a UTF-8 string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The UTF-8 string.
         *
         * @static
         *
         * @example
         *
         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
         */
        stringify: function(l) {
          try {
            return decodeURIComponent(escape(E.stringify(l)));
          } catch {
            throw new Error("Malformed UTF-8 data");
          }
        },
        /**
         * Converts a UTF-8 string to a word array.
         *
         * @param {string} utf8Str The UTF-8 string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
         */
        parse: function(l) {
          return E.parse(unescape(encodeURIComponent(l)));
        }
      }, d = u.BufferedBlockAlgorithm = _.extend({
        /**
         * Resets this block algorithm's data buffer to its initial state.
         *
         * @example
         *
         *     bufferedBlockAlgorithm.reset();
         */
        reset: function() {
          this._data = new g.init(), this._nDataBytes = 0;
        },
        /**
         * Adds new data to this block algorithm's buffer.
         *
         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
         *
         * @example
         *
         *     bufferedBlockAlgorithm._append('data');
         *     bufferedBlockAlgorithm._append(wordArray);
         */
        _append: function(l) {
          typeof l == "string" && (l = m.parse(l)), this._data.concat(l), this._nDataBytes += l.sigBytes;
        },
        /**
         * Processes available data blocks.
         *
         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
         *
         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
         *
         * @return {WordArray} The processed data.
         *
         * @example
         *
         *     var processedData = bufferedBlockAlgorithm._process();
         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
         */
        _process: function(l) {
          var f, w = this._data, S = w.words, y = w.sigBytes, b = this.blockSize, C = b * 4, x = y / C;
          l ? x = s.ceil(x) : x = s.max((x | 0) - this._minBufferSize, 0);
          var j = x * b, A = s.min(j * 4, y);
          if (j) {
            for (var L = 0; L < j; L += b)
              this._doProcessBlock(S, L);
            f = S.splice(0, j), w.sigBytes -= A;
          }
          return new g.init(f, A);
        },
        /**
         * Creates a copy of this object.
         *
         * @return {Object} The clone.
         *
         * @example
         *
         *     var clone = bufferedBlockAlgorithm.clone();
         */
        clone: function() {
          var l = _.clone.call(this);
          return l._data = this._data.clone(), l;
        },
        _minBufferSize: 0
      });
      u.Hasher = d.extend({
        /**
         * Configuration options.
         */
        cfg: _.extend(),
        /**
         * Initializes a newly created hasher.
         *
         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
         *
         * @example
         *
         *     var hasher = CryptoJS.algo.SHA256.create();
         */
        init: function(l) {
          this.cfg = this.cfg.extend(l), this.reset();
        },
        /**
         * Resets this hasher to its initial state.
         *
         * @example
         *
         *     hasher.reset();
         */
        reset: function() {
          d.reset.call(this), this._doReset();
        },
        /**
         * Updates this hasher with a message.
         *
         * @param {WordArray|string} messageUpdate The message to append.
         *
         * @return {Hasher} This hasher.
         *
         * @example
         *
         *     hasher.update('message');
         *     hasher.update(wordArray);
         */
        update: function(l) {
          return this._append(l), this._process(), this;
        },
        /**
         * Finalizes the hash computation.
         * Note that the finalize operation is effectively a destructive, read-once operation.
         *
         * @param {WordArray|string} messageUpdate (Optional) A final message update.
         *
         * @return {WordArray} The hash.
         *
         * @example
         *
         *     var hash = hasher.finalize();
         *     var hash = hasher.finalize('message');
         *     var hash = hasher.finalize(wordArray);
         */
        finalize: function(l) {
          l && this._append(l);
          var f = this._doFinalize();
          return f;
        },
        blockSize: 16,
        /**
         * Creates a shortcut function to a hasher's object interface.
         *
         * @param {Hasher} hasher The hasher to create a helper for.
         *
         * @return {Function} The shortcut function.
         *
         * @static
         *
         * @example
         *
         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
         */
        _createHelper: function(l) {
          return function(f, w) {
            return new l.init(w).finalize(f);
          };
        },
        /**
         * Creates a shortcut function to the HMAC's object interface.
         *
         * @param {Hasher} hasher The hasher to use in this HMAC helper.
         *
         * @return {Function} The shortcut function.
         *
         * @static
         *
         * @example
         *
         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
         */
        _createHmacHelper: function(l) {
          return function(f, w) {
            return new k.HMAC.init(l, w).finalize(f);
          };
        }
      });
      var k = c.algo = {};
      return c;
    }(Math);
    return r;
  });
})(yt);
var ie = yt.exports;
const dr = /* @__PURE__ */ Y(ie);
var bt = { exports: {} };
(function(e, t) {
  (function(r, s) {
    e.exports = s(ie);
  })(F, function(r) {
    return function(s) {
      var i = r, n = i.lib, o = n.WordArray, a = n.Hasher, c = i.algo, u = [], _ = [];
      (function() {
        function h(k) {
          for (var l = s.sqrt(k), f = 2; f <= l; f++)
            if (!(k % f))
              return !1;
          return !0;
        }
        function E(k) {
          return (k - (k | 0)) * 4294967296 | 0;
        }
        for (var m = 2, d = 0; d < 64; )
          h(m) && (d < 8 && (u[d] = E(s.pow(m, 1 / 2))), _[d] = E(s.pow(m, 1 / 3)), d++), m++;
      })();
      var g = [], p = c.SHA256 = a.extend({
        _doReset: function() {
          this._hash = new o.init(u.slice(0));
        },
        _doProcessBlock: function(h, E) {
          for (var m = this._hash.words, d = m[0], k = m[1], l = m[2], f = m[3], w = m[4], S = m[5], y = m[6], b = m[7], C = 0; C < 64; C++) {
            if (C < 16)
              g[C] = h[E + C] | 0;
            else {
              var x = g[C - 15], j = (x << 25 | x >>> 7) ^ (x << 14 | x >>> 18) ^ x >>> 3, A = g[C - 2], L = (A << 15 | A >>> 17) ^ (A << 13 | A >>> 19) ^ A >>> 10;
              g[C] = j + g[C - 7] + L + g[C - 16];
            }
            var G = w & S ^ ~w & y, ce = d & k ^ d & l ^ k & l, ue = (d << 30 | d >>> 2) ^ (d << 19 | d >>> 13) ^ (d << 10 | d >>> 22), le = (w << 26 | w >>> 6) ^ (w << 21 | w >>> 11) ^ (w << 7 | w >>> 25), Z = b + le + G + _[C] + g[C], de = ue + ce;
            b = y, y = S, S = w, w = f + Z | 0, f = l, l = k, k = d, d = Z + de | 0;
          }
          m[0] = m[0] + d | 0, m[1] = m[1] + k | 0, m[2] = m[2] + l | 0, m[3] = m[3] + f | 0, m[4] = m[4] + w | 0, m[5] = m[5] + S | 0, m[6] = m[6] + y | 0, m[7] = m[7] + b | 0;
        },
        _doFinalize: function() {
          var h = this._data, E = h.words, m = this._nDataBytes * 8, d = h.sigBytes * 8;
          return E[d >>> 5] |= 128 << 24 - d % 32, E[(d + 64 >>> 9 << 4) + 14] = s.floor(m / 4294967296), E[(d + 64 >>> 9 << 4) + 15] = m, h.sigBytes = E.length * 4, this._process(), this._hash;
        },
        clone: function() {
          var h = a.clone.call(this);
          return h._hash = this._hash.clone(), h;
        }
      });
      i.SHA256 = a._createHelper(p), i.HmacSHA256 = a._createHmacHelper(p);
    }(Math), r.SHA256;
  });
})(bt);
var hr = bt.exports;
const gr = /* @__PURE__ */ Y(hr);
var kt = { exports: {} };
(function(e, t) {
  (function(r, s) {
    e.exports = s(ie);
  })(F, function(r) {
    return function() {
      var s = r, i = s.lib, n = i.WordArray, o = s.enc;
      o.Base64 = {
        /**
         * Converts a word array to a Base64 string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The Base64 string.
         *
         * @static
         *
         * @example
         *
         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
         */
        stringify: function(c) {
          var u = c.words, _ = c.sigBytes, g = this._map;
          c.clamp();
          for (var p = [], h = 0; h < _; h += 3)
            for (var E = u[h >>> 2] >>> 24 - h % 4 * 8 & 255, m = u[h + 1 >>> 2] >>> 24 - (h + 1) % 4 * 8 & 255, d = u[h + 2 >>> 2] >>> 24 - (h + 2) % 4 * 8 & 255, k = E << 16 | m << 8 | d, l = 0; l < 4 && h + l * 0.75 < _; l++)
              p.push(g.charAt(k >>> 6 * (3 - l) & 63));
          var f = g.charAt(64);
          if (f)
            for (; p.length % 4; )
              p.push(f);
          return p.join("");
        },
        /**
         * Converts a Base64 string to a word array.
         *
         * @param {string} base64Str The Base64 string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
         */
        parse: function(c) {
          var u = c.length, _ = this._map, g = this._reverseMap;
          if (!g) {
            g = this._reverseMap = [];
            for (var p = 0; p < _.length; p++)
              g[_.charCodeAt(p)] = p;
          }
          var h = _.charAt(64);
          if (h) {
            var E = c.indexOf(h);
            E !== -1 && (u = E);
          }
          return a(c, u, g);
        },
        _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
      };
      function a(c, u, _) {
        for (var g = [], p = 0, h = 0; h < u; h++)
          if (h % 4) {
            var E = _[c.charCodeAt(h - 1)] << h % 4 * 2, m = _[c.charCodeAt(h)] >>> 6 - h % 4 * 2, d = E | m;
            g[p >>> 2] |= d << 24 - p % 4 * 8, p++;
          }
        return n.create(g, p);
      }
    }(), r.enc.Base64;
  });
})(kt);
var fr = kt.exports;
const ze = /* @__PURE__ */ Y(fr);
var Et = { exports: {} };
(function(e, t) {
  (function(r, s) {
    e.exports = s(ie);
  })(F, function(r) {
    return r.enc.Utf8;
  });
})(Et);
var pr = Et.exports;
const _r = /* @__PURE__ */ Y(pr);
function Ie(e) {
  this.message = e;
}
Ie.prototype = new Error(), Ie.prototype.name = "InvalidCharacterError";
var Je = typeof window < "u" && window.atob && window.atob.bind(window) || function(e) {
  var t = String(e).replace(/=+$/, "");
  if (t.length % 4 == 1)
    throw new Ie("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var r, s, i = 0, n = 0, o = ""; s = t.charAt(n++); ~s && (r = i % 4 ? 64 * r + s : s, i++ % 4) ? o += String.fromCharCode(255 & r >> (-2 * i & 6)) : 0)
    s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(s);
  return o;
};
function mr(e) {
  var t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function(r) {
      return decodeURIComponent(Je(r).replace(/(.)/g, function(s, i) {
        var n = i.charCodeAt(0).toString(16).toUpperCase();
        return n.length < 2 && (n = "0" + n), "%" + n;
      }));
    }(t);
  } catch {
    return Je(t);
  }
}
function se(e) {
  this.message = e;
}
function wr(e, t) {
  if (typeof e != "string")
    throw new se("Invalid token specified");
  var r = (t = t || {}).header === !0 ? 0 : 1;
  try {
    return JSON.parse(mr(e.split(".")[r]));
  } catch (s) {
    throw new se("Invalid token specified: " + s.message);
  }
}
se.prototype = new Error(), se.prototype.name = "InvalidTokenError";
var vr = {
  debug: () => {
  },
  info: () => {
  },
  warn: () => {
  },
  error: () => {
  }
}, O, q, W = /* @__PURE__ */ ((e) => (e[e.NONE = 0] = "NONE", e[e.ERROR = 1] = "ERROR", e[e.WARN = 2] = "WARN", e[e.INFO = 3] = "INFO", e[e.DEBUG = 4] = "DEBUG", e))(W || {});
((e) => {
  function t() {
    O = 3, q = vr;
  }
  e.reset = t;
  function r(i) {
    if (!(0 <= i && i <= 4))
      throw new Error("Invalid log level");
    O = i;
  }
  e.setLevel = r;
  function s(i) {
    q = i;
  }
  e.setLogger = s;
})(W || (W = {}));
var v = class {
  constructor(e) {
    this._name = e;
  }
  debug(...e) {
    O >= 4 && q.debug(v._format(this._name, this._method), ...e);
  }
  info(...e) {
    O >= 3 && q.info(v._format(this._name, this._method), ...e);
  }
  warn(...e) {
    O >= 2 && q.warn(v._format(this._name, this._method), ...e);
  }
  error(...e) {
    O >= 1 && q.error(v._format(this._name, this._method), ...e);
  }
  throw(e) {
    throw this.error(e), e;
  }
  create(e) {
    const t = Object.create(this);
    return t._method = e, t.debug("begin"), t;
  }
  static createStatic(e, t) {
    const r = new v(`${e}.${t}`);
    return r.debug("begin"), r;
  }
  static _format(e, t) {
    const r = `[${e}]`;
    return t ? `${r} ${t}:` : r;
  }
  // helpers for static class methods
  static debug(e, ...t) {
    O >= 4 && q.debug(v._format(e), ...t);
  }
  static info(e, ...t) {
    O >= 3 && q.info(v._format(e), ...t);
  }
  static warn(e, ...t) {
    O >= 2 && q.warn(v._format(e), ...t);
  }
  static error(e, ...t) {
    O >= 1 && q.error(v._format(e), ...t);
  }
};
W.reset();
var Sr = "10000000-1000-4000-8000-100000000000", M = class {
  static _randomWord() {
    return dr.lib.WordArray.random(1).words[0];
  }
  /**
   * Generates RFC4122 version 4 guid
   */
  static generateUUIDv4() {
    return Sr.replace(
      /[018]/g,
      (t) => (+t ^ M._randomWord() & 15 >> +t / 4).toString(16)
    ).replace(/-/g, "");
  }
  /**
   * PKCE: Generate a code verifier
   */
  static generateCodeVerifier() {
    return M.generateUUIDv4() + M.generateUUIDv4() + M.generateUUIDv4();
  }
  /**
   * PKCE: Generate a code challenge
   */
  static generateCodeChallenge(e) {
    try {
      const t = gr(e);
      return ze.stringify(t).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    } catch (t) {
      throw v.error("CryptoUtils.generateCodeChallenge", t), t;
    }
  }
  /**
   * Generates a base64-encoded string for a basic auth header
   */
  static generateBasicAuth(e, t) {
    const r = _r.parse([e, t].join(":"));
    return ze.stringify(r);
  }
}, $ = class {
  constructor(e) {
    this._name = e, this._logger = new v(`Event('${this._name}')`), this._callbacks = [];
  }
  addHandler(e) {
    return this._callbacks.push(e), () => this.removeHandler(e);
  }
  removeHandler(e) {
    const t = this._callbacks.lastIndexOf(e);
    t >= 0 && this._callbacks.splice(t, 1);
  }
  raise(...e) {
    this._logger.debug("raise:", ...e);
    for (const t of this._callbacks)
      t(...e);
  }
}, Ae = class {
  // IMPORTANT: doesn't validate the token
  static decode(e) {
    try {
      return wr(e);
    } catch (t) {
      throw v.error("JwtUtils.decode", t), t;
    }
  }
}, Ke = class {
  /**
   * Populates a map of window features with a placement centered in front of
   * the current window. If no explicit width is given, a default value is
   * binned into [800, 720, 600, 480, 360] based on the current window's width.
   */
  static center({ ...e }) {
    var t, r, s;
    return e.width == null && (e.width = (t = [800, 720, 600, 480].find((i) => i <= window.outerWidth / 1.618)) != null ? t : 360), (r = e.left) != null || (e.left = Math.max(0, Math.round(window.screenX + (window.outerWidth - e.width) / 2))), e.height != null && ((s = e.top) != null || (e.top = Math.max(0, Math.round(window.screenY + (window.outerHeight - e.height) / 2)))), e;
  }
  static serialize(e) {
    return Object.entries(e).filter(([, t]) => t != null).map(([t, r]) => `${t}=${typeof r != "boolean" ? r : r ? "yes" : "no"}`).join(",");
  }
}, P = class extends $ {
  constructor() {
    super(...arguments), this._logger = new v(`Timer('${this._name}')`), this._timerHandle = null, this._expiration = 0, this._callback = () => {
      const e = this._expiration - P.getEpochTime();
      this._logger.debug("timer completes in", e), this._expiration <= P.getEpochTime() && (this.cancel(), super.raise());
    };
  }
  // get the time
  static getEpochTime() {
    return Math.floor(Date.now() / 1e3);
  }
  init(e) {
    const t = this._logger.create("init");
    e = Math.max(Math.floor(e), 1);
    const r = P.getEpochTime() + e;
    if (this.expiration === r && this._timerHandle) {
      t.debug("skipping since already initialized for expiration at", this.expiration);
      return;
    }
    this.cancel(), t.debug("using duration", e), this._expiration = r;
    const s = Math.min(e, 5);
    this._timerHandle = setInterval(this._callback, s * 1e3);
  }
  get expiration() {
    return this._expiration;
  }
  cancel() {
    this._logger.create("cancel"), this._timerHandle && (clearInterval(this._timerHandle), this._timerHandle = null);
  }
}, Pe = class {
  static readParams(e, t = "query") {
    if (!e)
      throw new TypeError("Invalid URL");
    const s = new URL(e, "http://127.0.0.1")[t === "fragment" ? "hash" : "search"];
    return new URLSearchParams(s.slice(1));
  }
}, z = class extends Error {
  constructor(e, t) {
    var r, s, i;
    if (super(e.error_description || e.error || ""), this.form = t, this.name = "ErrorResponse", !e.error)
      throw v.error("ErrorResponse", "No error passed"), new Error("No error passed");
    this.error = e.error, this.error_description = (r = e.error_description) != null ? r : null, this.error_uri = (s = e.error_uri) != null ? s : null, this.state = e.userState, this.session_state = (i = e.session_state) != null ? i : null;
  }
}, Me = class extends Error {
  constructor(e) {
    super(e), this.name = "ErrorTimeout";
  }
}, yr = class {
  constructor(e) {
    this._logger = new v("AccessTokenEvents"), this._expiringTimer = new P("Access token expiring"), this._expiredTimer = new P("Access token expired"), this._expiringNotificationTimeInSeconds = e.expiringNotificationTimeInSeconds;
  }
  load(e) {
    const t = this._logger.create("load");
    if (e.access_token && e.expires_in !== void 0) {
      const r = e.expires_in;
      if (t.debug("access token present, remaining duration:", r), r > 0) {
        let i = r - this._expiringNotificationTimeInSeconds;
        i <= 0 && (i = 1), t.debug("registering expiring timer, raising in", i, "seconds"), this._expiringTimer.init(i);
      } else
        t.debug("canceling existing expiring timer because we're past expiration."), this._expiringTimer.cancel();
      const s = r + 1;
      t.debug("registering expired timer, raising in", s, "seconds"), this._expiredTimer.init(s);
    } else
      this._expiringTimer.cancel(), this._expiredTimer.cancel();
  }
  unload() {
    this._logger.debug("unload: canceling existing access token timers"), this._expiringTimer.cancel(), this._expiredTimer.cancel();
  }
  /**
   * Add callback: Raised prior to the access token expiring.
   */
  addAccessTokenExpiring(e) {
    return this._expiringTimer.addHandler(e);
  }
  /**
   * Remove callback: Raised prior to the access token expiring.
   */
  removeAccessTokenExpiring(e) {
    this._expiringTimer.removeHandler(e);
  }
  /**
   * Add callback: Raised after the access token has expired.
   */
  addAccessTokenExpired(e) {
    return this._expiredTimer.addHandler(e);
  }
  /**
   * Remove callback: Raised after the access token has expired.
   */
  removeAccessTokenExpired(e) {
    this._expiredTimer.removeHandler(e);
  }
}, br = class {
  constructor(e, t, r, s, i) {
    this._callback = e, this._client_id = t, this._intervalInSeconds = s, this._stopOnError = i, this._logger = new v("CheckSessionIFrame"), this._timer = null, this._session_state = null, this._message = (o) => {
      o.origin === this._frame_origin && o.source === this._frame.contentWindow && (o.data === "error" ? (this._logger.error("error message from check session op iframe"), this._stopOnError && this.stop()) : o.data === "changed" ? (this._logger.debug("changed message from check session op iframe"), this.stop(), this._callback()) : this._logger.debug(o.data + " message from check session op iframe"));
    };
    const n = new URL(r);
    this._frame_origin = n.origin, this._frame = window.document.createElement("iframe"), this._frame.style.visibility = "hidden", this._frame.style.position = "fixed", this._frame.style.left = "-1000px", this._frame.style.top = "0", this._frame.width = "0", this._frame.height = "0", this._frame.src = n.href;
  }
  load() {
    return new Promise((e) => {
      this._frame.onload = () => {
        e();
      }, window.document.body.appendChild(this._frame), window.addEventListener("message", this._message, !1);
    });
  }
  start(e) {
    if (this._session_state === e)
      return;
    this._logger.create("start"), this.stop(), this._session_state = e;
    const t = () => {
      !this._frame.contentWindow || !this._session_state || this._frame.contentWindow.postMessage(this._client_id + " " + this._session_state, this._frame_origin);
    };
    t(), this._timer = setInterval(t, this._intervalInSeconds * 1e3);
  }
  stop() {
    this._logger.create("stop"), this._session_state = null, this._timer && (clearInterval(this._timer), this._timer = null);
  }
}, Ct = class {
  constructor() {
    this._logger = new v("InMemoryWebStorage"), this._data = {};
  }
  clear() {
    this._logger.create("clear"), this._data = {};
  }
  getItem(e) {
    return this._logger.create(`getItem('${e}')`), this._data[e];
  }
  setItem(e, t) {
    this._logger.create(`setItem('${e}')`), this._data[e] = t;
  }
  removeItem(e) {
    this._logger.create(`removeItem('${e}')`), delete this._data[e];
  }
  get length() {
    return Object.getOwnPropertyNames(this._data).length;
  }
  key(e) {
    return Object.getOwnPropertyNames(this._data)[e];
  }
}, je = class {
  constructor(e = [], t = null, r = {}) {
    this._jwtHandler = t, this._extraHeaders = r, this._logger = new v("JsonService"), this._contentTypes = [], this._contentTypes.push(...e, "application/json"), t && this._contentTypes.push("application/jwt");
  }
  async fetchWithTimeout(e, t = {}) {
    const { timeoutInSeconds: r, ...s } = t;
    if (!r)
      return await fetch(e, s);
    const i = new AbortController(), n = setTimeout(() => i.abort(), r * 1e3);
    try {
      return await fetch(e, {
        ...t,
        signal: i.signal
      });
    } catch (o) {
      throw o instanceof DOMException && o.name === "AbortError" ? new Me("Network timed out") : o;
    } finally {
      clearTimeout(n);
    }
  }
  async getJson(e, {
    token: t,
    credentials: r
  } = {}) {
    const s = this._logger.create("getJson"), i = {
      Accept: this._contentTypes.join(", ")
    };
    t && (s.debug("token passed, setting Authorization header"), i.Authorization = "Bearer " + t), this.appendExtraHeaders(i);
    let n;
    try {
      s.debug("url:", e), n = await this.fetchWithTimeout(e, { method: "GET", headers: i, credentials: r });
    } catch (c) {
      throw s.error("Network Error"), c;
    }
    s.debug("HTTP response received, status", n.status);
    const o = n.headers.get("Content-Type");
    if (o && !this._contentTypes.find((c) => o.startsWith(c)) && s.throw(new Error(`Invalid response Content-Type: ${o ?? "undefined"}, from URL: ${e}`)), n.ok && this._jwtHandler && (o != null && o.startsWith("application/jwt")))
      return await this._jwtHandler(await n.text());
    let a;
    try {
      a = await n.json();
    } catch (c) {
      throw s.error("Error parsing JSON response", c), n.ok ? c : new Error(`${n.statusText} (${n.status})`);
    }
    if (!n.ok)
      throw s.error("Error from server:", a), a.error ? new z(a) : new Error(`${n.statusText} (${n.status}): ${JSON.stringify(a)}`);
    return a;
  }
  async postForm(e, {
    body: t,
    basicAuth: r,
    timeoutInSeconds: s,
    initCredentials: i
  }) {
    const n = this._logger.create("postForm"), o = {
      Accept: this._contentTypes.join(", "),
      "Content-Type": "application/x-www-form-urlencoded"
    };
    r !== void 0 && (o.Authorization = "Basic " + r), this.appendExtraHeaders(o);
    let a;
    try {
      n.debug("url:", e), a = await this.fetchWithTimeout(e, { method: "POST", headers: o, body: t, timeoutInSeconds: s, credentials: i });
    } catch (g) {
      throw n.error("Network error"), g;
    }
    n.debug("HTTP response received, status", a.status);
    const c = a.headers.get("Content-Type");
    if (c && !this._contentTypes.find((g) => c.startsWith(g)))
      throw new Error(`Invalid response Content-Type: ${c ?? "undefined"}, from URL: ${e}`);
    const u = await a.text();
    let _ = {};
    if (u)
      try {
        _ = JSON.parse(u);
      } catch (g) {
        throw n.error("Error parsing JSON response", g), a.ok ? g : new Error(`${a.statusText} (${a.status})`);
      }
    if (!a.ok)
      throw n.error("Error from server:", _), _.error ? new z(_, t) : new Error(`${a.statusText} (${a.status}): ${JSON.stringify(_)}`);
    return _;
  }
  appendExtraHeaders(e) {
    const t = this._logger.create("appendExtraHeaders"), r = Object.keys(this._extraHeaders), s = [
      "authorization",
      "accept",
      "content-type"
    ];
    r.length !== 0 && r.forEach((i) => {
      if (s.includes(i.toLocaleLowerCase())) {
        t.warn("Protected header could not be overridden", i, s);
        return;
      }
      const n = typeof this._extraHeaders[i] == "function" ? this._extraHeaders[i]() : this._extraHeaders[i];
      n && n !== "" && (e[i] = n);
    });
  }
}, kr = class {
  constructor(e) {
    this._settings = e, this._logger = new v("MetadataService"), this._signingKeys = null, this._metadata = null, this._metadataUrl = this._settings.metadataUrl, this._jsonService = new je(
      ["application/jwk-set+json"],
      null,
      this._settings.extraHeaders
    ), this._settings.signingKeys && (this._logger.debug("using signingKeys from settings"), this._signingKeys = this._settings.signingKeys), this._settings.metadata && (this._logger.debug("using metadata from settings"), this._metadata = this._settings.metadata), this._settings.fetchRequestCredentials && (this._logger.debug("using fetchRequestCredentials from settings"), this._fetchRequestCredentials = this._settings.fetchRequestCredentials);
  }
  resetSigningKeys() {
    this._signingKeys = null;
  }
  async getMetadata() {
    const e = this._logger.create("getMetadata");
    if (this._metadata)
      return e.debug("using cached values"), this._metadata;
    if (!this._metadataUrl)
      throw e.throw(new Error("No authority or metadataUrl configured on settings")), null;
    e.debug("getting metadata from", this._metadataUrl);
    const t = await this._jsonService.getJson(this._metadataUrl, { credentials: this._fetchRequestCredentials });
    return e.debug("merging remote JSON with seed metadata"), this._metadata = Object.assign({}, this._settings.metadataSeed, t), this._metadata;
  }
  getIssuer() {
    return this._getMetadataProperty("issuer");
  }
  getAuthorizationEndpoint() {
    return this._getMetadataProperty("authorization_endpoint");
  }
  getUserInfoEndpoint() {
    return this._getMetadataProperty("userinfo_endpoint");
  }
  getTokenEndpoint(e = !0) {
    return this._getMetadataProperty("token_endpoint", e);
  }
  getCheckSessionIframe() {
    return this._getMetadataProperty("check_session_iframe", !0);
  }
  getEndSessionEndpoint() {
    return this._getMetadataProperty("end_session_endpoint", !0);
  }
  getRevocationEndpoint(e = !0) {
    return this._getMetadataProperty("revocation_endpoint", e);
  }
  getKeysEndpoint(e = !0) {
    return this._getMetadataProperty("jwks_uri", e);
  }
  async _getMetadataProperty(e, t = !1) {
    const r = this._logger.create(`_getMetadataProperty('${e}')`), s = await this.getMetadata();
    if (r.debug("resolved"), s[e] === void 0) {
      if (t === !0) {
        r.warn("Metadata does not contain optional property");
        return;
      }
      r.throw(new Error("Metadata does not contain property " + e));
    }
    return s[e];
  }
  async getSigningKeys() {
    const e = this._logger.create("getSigningKeys");
    if (this._signingKeys)
      return e.debug("returning signingKeys from cache"), this._signingKeys;
    const t = await this.getKeysEndpoint(!1);
    e.debug("got jwks_uri", t);
    const r = await this._jsonService.getJson(t);
    if (e.debug("got key set", r), !Array.isArray(r.keys))
      throw e.throw(new Error("Missing keys on keyset")), null;
    return this._signingKeys = r.keys, this._signingKeys;
  }
}, xt = class {
  constructor({
    prefix: e = "oidc.",
    store: t = localStorage
  } = {}) {
    this._logger = new v("WebStorageStateStore"), this._store = t, this._prefix = e;
  }
  async set(e, t) {
    this._logger.create(`set('${e}')`), e = this._prefix + e, await this._store.setItem(e, t);
  }
  async get(e) {
    return this._logger.create(`get('${e}')`), e = this._prefix + e, await this._store.getItem(e);
  }
  async remove(e) {
    this._logger.create(`remove('${e}')`), e = this._prefix + e;
    const t = await this._store.getItem(e);
    return await this._store.removeItem(e), t;
  }
  async getAllKeys() {
    this._logger.create("getAllKeys");
    const e = await this._store.length, t = [];
    for (let r = 0; r < e; r++) {
      const s = await this._store.key(r);
      s && s.indexOf(this._prefix) === 0 && t.push(s.substr(this._prefix.length));
    }
    return t;
  }
}, Er = "code", Cr = "openid", xr = "client_secret_post", Tr = "query", Rr = 60 * 15, Ir = 60 * 5, Ue = class {
  constructor({
    // metadata related
    authority: e,
    metadataUrl: t,
    metadata: r,
    signingKeys: s,
    metadataSeed: i,
    // client related
    client_id: n,
    client_secret: o,
    response_type: a = Er,
    scope: c = Cr,
    redirect_uri: u,
    post_logout_redirect_uri: _,
    client_authentication: g = xr,
    // optional protocol
    prompt: p,
    display: h,
    max_age: E,
    ui_locales: m,
    acr_values: d,
    resource: k,
    response_mode: l = Tr,
    // behavior flags
    filterProtocolClaims: f = !0,
    loadUserInfo: w = !1,
    staleStateAgeInSeconds: S = Rr,
    clockSkewInSeconds: y = Ir,
    userInfoJwtIssuer: b = "OP",
    mergeClaims: C = !1,
    disablePKCE: x = !1,
    // other behavior
    stateStore: j,
    refreshTokenCredentials: A,
    revokeTokenAdditionalContentTypes: L,
    fetchRequestCredentials: G,
    refreshTokenAllowedScope: ce,
    // extra
    extraQueryParams: ue = {},
    extraTokenParams: le = {},
    extraHeaders: Z = {}
  }) {
    if (this.authority = e, t ? this.metadataUrl = t : (this.metadataUrl = e, e && (this.metadataUrl.endsWith("/") || (this.metadataUrl += "/"), this.metadataUrl += ".well-known/openid-configuration")), this.metadata = r, this.metadataSeed = i, this.signingKeys = s, this.client_id = n, this.client_secret = o, this.response_type = a, this.scope = c, this.redirect_uri = u, this.post_logout_redirect_uri = _, this.client_authentication = g, this.prompt = p, this.display = h, this.max_age = E, this.ui_locales = m, this.acr_values = d, this.resource = k, this.response_mode = l, this.filterProtocolClaims = f ?? !0, this.loadUserInfo = !!w, this.staleStateAgeInSeconds = S, this.clockSkewInSeconds = y, this.userInfoJwtIssuer = b, this.mergeClaims = !!C, this.disablePKCE = !!x, this.revokeTokenAdditionalContentTypes = L, G && A && console.warn("Both fetchRequestCredentials and refreshTokenCredentials is set. Only fetchRequestCredentials will be used."), this.fetchRequestCredentials = G || A || "same-origin", j)
      this.stateStore = j;
    else {
      const de = typeof window < "u" ? window.localStorage : new Ct();
      this.stateStore = new xt({ store: de });
    }
    this.refreshTokenAllowedScope = ce, this.extraQueryParams = ue, this.extraTokenParams = le, this.extraHeaders = Z;
  }
}, Ar = class {
  constructor(e, t) {
    this._settings = e, this._metadataService = t, this._logger = new v("UserInfoService"), this._getClaimsFromJwt = async (r) => {
      const s = this._logger.create("_getClaimsFromJwt");
      try {
        const i = Ae.decode(r);
        return s.debug("JWT decoding successful"), i;
      } catch (i) {
        throw s.error("Error parsing JWT response"), i;
      }
    }, this._jsonService = new je(
      void 0,
      this._getClaimsFromJwt,
      this._settings.extraHeaders
    );
  }
  async getClaims(e) {
    const t = this._logger.create("getClaims");
    e || this._logger.throw(new Error("No token passed"));
    const r = await this._metadataService.getUserInfoEndpoint();
    t.debug("got userinfo url", r);
    const s = await this._jsonService.getJson(r, {
      token: e,
      credentials: this._settings.fetchRequestCredentials
    });
    return t.debug("got claims", s), s;
  }
}, Tt = class {
  constructor(e, t) {
    this._settings = e, this._metadataService = t, this._logger = new v("TokenClient"), this._jsonService = new je(
      this._settings.revokeTokenAdditionalContentTypes,
      null,
      this._settings.extraHeaders
    );
  }
  /**
   * Exchange code.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.1.3
   */
  async exchangeCode({
    grant_type: e = "authorization_code",
    redirect_uri: t = this._settings.redirect_uri,
    client_id: r = this._settings.client_id,
    client_secret: s = this._settings.client_secret,
    ...i
  }) {
    const n = this._logger.create("exchangeCode");
    r || n.throw(new Error("A client_id is required")), t || n.throw(new Error("A redirect_uri is required")), i.code || n.throw(new Error("A code is required"));
    const o = new URLSearchParams({ grant_type: e, redirect_uri: t });
    for (const [_, g] of Object.entries(i))
      g != null && o.set(_, g);
    let a;
    switch (this._settings.client_authentication) {
      case "client_secret_basic":
        if (!s)
          throw n.throw(new Error("A client_secret is required")), null;
        a = M.generateBasicAuth(r, s);
        break;
      case "client_secret_post":
        o.append("client_id", r), s && o.append("client_secret", s);
        break;
    }
    const c = await this._metadataService.getTokenEndpoint(!1);
    n.debug("got token endpoint");
    const u = await this._jsonService.postForm(c, { body: o, basicAuth: a, initCredentials: this._settings.fetchRequestCredentials });
    return n.debug("got response"), u;
  }
  /**
   * Exchange credentials.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.3.2
   */
  async exchangeCredentials({
    grant_type: e = "password",
    client_id: t = this._settings.client_id,
    client_secret: r = this._settings.client_secret,
    scope: s = this._settings.scope,
    ...i
  }) {
    const n = this._logger.create("exchangeCredentials");
    t || n.throw(new Error("A client_id is required"));
    const o = new URLSearchParams({ grant_type: e, scope: s });
    for (const [_, g] of Object.entries(i))
      g != null && o.set(_, g);
    let a;
    switch (this._settings.client_authentication) {
      case "client_secret_basic":
        if (!r)
          throw n.throw(new Error("A client_secret is required")), null;
        a = M.generateBasicAuth(t, r);
        break;
      case "client_secret_post":
        o.append("client_id", t), r && o.append("client_secret", r);
        break;
    }
    const c = await this._metadataService.getTokenEndpoint(!1);
    n.debug("got token endpoint");
    const u = await this._jsonService.postForm(c, { body: o, basicAuth: a, initCredentials: this._settings.fetchRequestCredentials });
    return n.debug("got response"), u;
  }
  /**
   * Exchange a refresh token.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-6
   */
  async exchangeRefreshToken({
    grant_type: e = "refresh_token",
    client_id: t = this._settings.client_id,
    client_secret: r = this._settings.client_secret,
    timeoutInSeconds: s,
    ...i
  }) {
    const n = this._logger.create("exchangeRefreshToken");
    t || n.throw(new Error("A client_id is required")), i.refresh_token || n.throw(new Error("A refresh_token is required"));
    const o = new URLSearchParams({ grant_type: e });
    for (const [_, g] of Object.entries(i))
      Array.isArray(g) ? g.forEach((p) => o.append(_, p)) : g != null && o.set(_, g);
    let a;
    switch (this._settings.client_authentication) {
      case "client_secret_basic":
        if (!r)
          throw n.throw(new Error("A client_secret is required")), null;
        a = M.generateBasicAuth(t, r);
        break;
      case "client_secret_post":
        o.append("client_id", t), r && o.append("client_secret", r);
        break;
    }
    const c = await this._metadataService.getTokenEndpoint(!1);
    n.debug("got token endpoint");
    const u = await this._jsonService.postForm(c, { body: o, basicAuth: a, timeoutInSeconds: s, initCredentials: this._settings.fetchRequestCredentials });
    return n.debug("got response"), u;
  }
  /**
   * Revoke an access or refresh token.
   *
   * @see https://datatracker.ietf.org/doc/html/rfc7009#section-2.1
   */
  async revoke(e) {
    var t;
    const r = this._logger.create("revoke");
    e.token || r.throw(new Error("A token is required"));
    const s = await this._metadataService.getRevocationEndpoint(!1);
    r.debug(`got revocation endpoint, revoking ${(t = e.token_type_hint) != null ? t : "default token type"}`);
    const i = new URLSearchParams();
    for (const [n, o] of Object.entries(e))
      o != null && i.set(n, o);
    i.set("client_id", this._settings.client_id), this._settings.client_secret && i.set("client_secret", this._settings.client_secret), await this._jsonService.postForm(s, { body: i }), r.debug("got response");
  }
}, Pr = class {
  constructor(e, t, r) {
    this._settings = e, this._metadataService = t, this._claimsService = r, this._logger = new v("ResponseValidator"), this._userInfoService = new Ar(this._settings, this._metadataService), this._tokenClient = new Tt(this._settings, this._metadataService);
  }
  async validateSigninResponse(e, t) {
    const r = this._logger.create("validateSigninResponse");
    this._processSigninState(e, t), r.debug("state processed"), await this._processCode(e, t), r.debug("code processed"), e.isOpenId && this._validateIdTokenAttributes(e), r.debug("tokens validated"), await this._processClaims(e, t == null ? void 0 : t.skipUserInfo, e.isOpenId), r.debug("claims processed");
  }
  async validateCredentialsResponse(e, t) {
    const r = this._logger.create("validateCredentialsResponse");
    e.isOpenId && this._validateIdTokenAttributes(e), r.debug("tokens validated"), await this._processClaims(e, t, e.isOpenId), r.debug("claims processed");
  }
  async validateRefreshResponse(e, t) {
    var r, s;
    const i = this._logger.create("validateRefreshResponse");
    e.userState = t.data, (r = e.session_state) != null || (e.session_state = t.session_state), (s = e.scope) != null || (e.scope = t.scope), e.isOpenId && e.id_token && (this._validateIdTokenAttributes(e, t.id_token), i.debug("ID Token validated")), e.id_token || (e.id_token = t.id_token, e.profile = t.profile);
    const n = e.isOpenId && !!e.id_token;
    await this._processClaims(e, !1, n), i.debug("claims processed");
  }
  validateSignoutResponse(e, t) {
    const r = this._logger.create("validateSignoutResponse");
    if (t.id !== e.state && r.throw(new Error("State does not match")), r.debug("state validated"), e.userState = t.data, e.error)
      throw r.warn("Response was error", e.error), new z(e);
  }
  _processSigninState(e, t) {
    var r;
    const s = this._logger.create("_processSigninState");
    if (t.id !== e.state && s.throw(new Error("State does not match")), t.client_id || s.throw(new Error("No client_id on state")), t.authority || s.throw(new Error("No authority on state")), this._settings.authority !== t.authority && s.throw(new Error("authority mismatch on settings vs. signin state")), this._settings.client_id && this._settings.client_id !== t.client_id && s.throw(new Error("client_id mismatch on settings vs. signin state")), s.debug("state validated"), e.userState = t.data, (r = e.scope) != null || (e.scope = t.scope), e.error)
      throw s.warn("Response was error", e.error), new z(e);
    t.code_verifier && !e.code && s.throw(new Error("Expected code in response"));
  }
  async _processClaims(e, t = !1, r = !0) {
    const s = this._logger.create("_processClaims");
    if (e.profile = this._claimsService.filterProtocolClaims(e.profile), t || !this._settings.loadUserInfo || !e.access_token) {
      s.debug("not loading user info");
      return;
    }
    s.debug("loading user info");
    const i = await this._userInfoService.getClaims(e.access_token);
    s.debug("user info claims received from user info endpoint"), r && i.sub !== e.profile.sub && s.throw(new Error("subject from UserInfo response does not match subject in ID Token")), e.profile = this._claimsService.mergeClaims(e.profile, this._claimsService.filterProtocolClaims(i)), s.debug("user info claims received, updated profile:", e.profile);
  }
  async _processCode(e, t) {
    const r = this._logger.create("_processCode");
    if (e.code) {
      r.debug("Validating code");
      const s = await this._tokenClient.exchangeCode({
        client_id: t.client_id,
        client_secret: t.client_secret,
        code: e.code,
        redirect_uri: t.redirect_uri,
        code_verifier: t.code_verifier,
        ...t.extraTokenParams
      });
      Object.assign(e, s);
    } else
      r.debug("No code to process");
  }
  _validateIdTokenAttributes(e, t) {
    var r;
    const s = this._logger.create("_validateIdTokenAttributes");
    s.debug("decoding ID Token JWT");
    const i = Ae.decode((r = e.id_token) != null ? r : "");
    if (i.sub || s.throw(new Error("ID Token is missing a subject claim")), t) {
      const n = Ae.decode(t);
      i.sub !== n.sub && s.throw(new Error("sub in id_token does not match current sub")), i.auth_time && i.auth_time !== n.auth_time && s.throw(new Error("auth_time in id_token does not match original auth_time")), i.azp && i.azp !== n.azp && s.throw(new Error("azp in id_token does not match original azp")), !i.azp && n.azp && s.throw(new Error("azp not in id_token, but present in original id_token"));
    }
    e.profile = i;
  }
}, X = class {
  constructor(e) {
    this.id = e.id || M.generateUUIDv4(), this.data = e.data, e.created && e.created > 0 ? this.created = e.created : this.created = P.getEpochTime(), this.request_type = e.request_type;
  }
  toStorageString() {
    return new v("State").create("toStorageString"), JSON.stringify({
      id: this.id,
      data: this.data,
      created: this.created,
      request_type: this.request_type
    });
  }
  static fromStorageString(e) {
    return v.createStatic("State", "fromStorageString"), new X(JSON.parse(e));
  }
  static async clearStaleState(e, t) {
    const r = v.createStatic("State", "clearStaleState"), s = P.getEpochTime() - t, i = await e.getAllKeys();
    r.debug("got keys", i);
    for (let n = 0; n < i.length; n++) {
      const o = i[n], a = await e.get(o);
      let c = !1;
      if (a)
        try {
          const u = X.fromStorageString(a);
          r.debug("got item from key:", o, u.created), u.created <= s && (c = !0);
        } catch (u) {
          r.error("Error parsing state for key:", o, u), c = !0;
        }
      else
        r.debug("no item in storage for key:", o), c = !0;
      c && (r.debug("removed item for key:", o), e.remove(o));
    }
  }
}, He = class extends X {
  constructor(e) {
    super(e), e.code_verifier === !0 ? this.code_verifier = M.generateCodeVerifier() : e.code_verifier && (this.code_verifier = e.code_verifier), this.code_verifier && (this.code_challenge = M.generateCodeChallenge(this.code_verifier)), this.authority = e.authority, this.client_id = e.client_id, this.redirect_uri = e.redirect_uri, this.scope = e.scope, this.client_secret = e.client_secret, this.extraTokenParams = e.extraTokenParams, this.response_mode = e.response_mode, this.skipUserInfo = e.skipUserInfo;
  }
  toStorageString() {
    return new v("SigninState").create("toStorageString"), JSON.stringify({
      id: this.id,
      data: this.data,
      created: this.created,
      request_type: this.request_type,
      code_verifier: this.code_verifier,
      authority: this.authority,
      client_id: this.client_id,
      redirect_uri: this.redirect_uri,
      scope: this.scope,
      client_secret: this.client_secret,
      extraTokenParams: this.extraTokenParams,
      response_mode: this.response_mode,
      skipUserInfo: this.skipUserInfo
    });
  }
  static fromStorageString(e) {
    v.createStatic("SigninState", "fromStorageString");
    const t = JSON.parse(e);
    return new He(t);
  }
}, Ur = class {
  constructor({
    // mandatory
    url: e,
    authority: t,
    client_id: r,
    redirect_uri: s,
    response_type: i,
    scope: n,
    // optional
    state_data: o,
    response_mode: a,
    request_type: c,
    client_secret: u,
    nonce: _,
    resource: g,
    skipUserInfo: p,
    extraQueryParams: h,
    extraTokenParams: E,
    disablePKCE: m,
    ...d
  }) {
    if (this._logger = new v("SigninRequest"), !e)
      throw this._logger.error("ctor: No url passed"), new Error("url");
    if (!r)
      throw this._logger.error("ctor: No client_id passed"), new Error("client_id");
    if (!s)
      throw this._logger.error("ctor: No redirect_uri passed"), new Error("redirect_uri");
    if (!i)
      throw this._logger.error("ctor: No response_type passed"), new Error("response_type");
    if (!n)
      throw this._logger.error("ctor: No scope passed"), new Error("scope");
    if (!t)
      throw this._logger.error("ctor: No authority passed"), new Error("authority");
    this.state = new He({
      data: o,
      request_type: c,
      code_verifier: !m,
      client_id: r,
      authority: t,
      redirect_uri: s,
      response_mode: a,
      client_secret: u,
      scope: n,
      extraTokenParams: E,
      skipUserInfo: p
    });
    const k = new URL(e);
    k.searchParams.append("client_id", r), k.searchParams.append("redirect_uri", s), k.searchParams.append("response_type", i), k.searchParams.append("scope", n), _ && k.searchParams.append("nonce", _), k.searchParams.append("state", this.state.id), this.state.code_challenge && (k.searchParams.append("code_challenge", this.state.code_challenge), k.searchParams.append("code_challenge_method", "S256")), g && (Array.isArray(g) ? g : [g]).forEach((f) => k.searchParams.append("resource", f));
    for (const [l, f] of Object.entries({ response_mode: a, ...d, ...h }))
      f != null && k.searchParams.append(l, f.toString());
    this.url = k.href;
  }
}, Or = "openid", he = class {
  constructor(e) {
    this.access_token = "", this.token_type = "", this.profile = {}, this.state = e.get("state"), this.session_state = e.get("session_state"), this.error = e.get("error"), this.error_description = e.get("error_description"), this.error_uri = e.get("error_uri"), this.code = e.get("code");
  }
  get expires_in() {
    if (this.expires_at !== void 0)
      return this.expires_at - P.getEpochTime();
  }
  set expires_in(e) {
    typeof e == "string" && (e = Number(e)), e !== void 0 && e >= 0 && (this.expires_at = Math.floor(e) + P.getEpochTime());
  }
  get isOpenId() {
    var e;
    return ((e = this.scope) == null ? void 0 : e.split(" ").includes(Or)) || !!this.id_token;
  }
}, qr = class {
  constructor({
    url: e,
    state_data: t,
    id_token_hint: r,
    post_logout_redirect_uri: s,
    extraQueryParams: i,
    request_type: n,
    client_id: o
  }) {
    if (this._logger = new v("SignoutRequest"), !e)
      throw this._logger.error("ctor: No url passed"), new Error("url");
    const a = new URL(e);
    r && a.searchParams.append("id_token_hint", r), o && a.searchParams.append("client_id", o), s && (a.searchParams.append("post_logout_redirect_uri", s), t && (this.state = new X({ data: t, request_type: n }), a.searchParams.append("state", this.state.id)));
    for (const [c, u] of Object.entries({ ...i }))
      u != null && a.searchParams.append(c, u.toString());
    this.url = a.href;
  }
}, Nr = class {
  constructor(e) {
    this.state = e.get("state"), this.error = e.get("error"), this.error_description = e.get("error_description"), this.error_uri = e.get("error_uri");
  }
}, Mr = [
  "nbf",
  "jti",
  "auth_time",
  "nonce",
  "acr",
  "amr",
  "azp",
  "at_hash"
  // https://openid.net/specs/openid-connect-core-1_0.html#CodeIDToken
], jr = ["sub", "iss", "aud", "exp", "iat"], Hr = class {
  constructor(e) {
    this._settings = e, this._logger = new v("ClaimsService");
  }
  filterProtocolClaims(e) {
    const t = { ...e };
    if (this._settings.filterProtocolClaims) {
      let r;
      Array.isArray(this._settings.filterProtocolClaims) ? r = this._settings.filterProtocolClaims : r = Mr;
      for (const s of r)
        jr.includes(s) || delete t[s];
    }
    return t;
  }
  mergeClaims(e, t) {
    const r = { ...e };
    for (const [s, i] of Object.entries(t))
      for (const n of Array.isArray(i) ? i : [i]) {
        const o = r[s];
        o ? Array.isArray(o) ? o.includes(n) || o.push(n) : r[s] !== n && (typeof n == "object" && this._settings.mergeClaims ? r[s] = this.mergeClaims(o, n) : r[s] = [o, n]) : r[s] = n;
      }
    return r;
  }
}, Br = class {
  constructor(e, t) {
    this._logger = new v("OidcClient"), this.settings = e instanceof Ue ? e : new Ue(e), this.metadataService = t ?? new kr(this.settings), this._claimsService = new Hr(this.settings), this._validator = new Pr(this.settings, this.metadataService, this._claimsService), this._tokenClient = new Tt(this.settings, this.metadataService);
  }
  async createSigninRequest({
    state: e,
    request: t,
    request_uri: r,
    request_type: s,
    id_token_hint: i,
    login_hint: n,
    skipUserInfo: o,
    nonce: a,
    response_type: c = this.settings.response_type,
    scope: u = this.settings.scope,
    redirect_uri: _ = this.settings.redirect_uri,
    prompt: g = this.settings.prompt,
    display: p = this.settings.display,
    max_age: h = this.settings.max_age,
    ui_locales: E = this.settings.ui_locales,
    acr_values: m = this.settings.acr_values,
    resource: d = this.settings.resource,
    response_mode: k = this.settings.response_mode,
    extraQueryParams: l = this.settings.extraQueryParams,
    extraTokenParams: f = this.settings.extraTokenParams
  }) {
    const w = this._logger.create("createSigninRequest");
    if (c !== "code")
      throw new Error("Only the Authorization Code flow (with PKCE) is supported");
    const S = await this.metadataService.getAuthorizationEndpoint();
    w.debug("Received authorization endpoint", S);
    const y = new Ur({
      url: S,
      authority: this.settings.authority,
      client_id: this.settings.client_id,
      redirect_uri: _,
      response_type: c,
      scope: u,
      state_data: e,
      prompt: g,
      display: p,
      max_age: h,
      ui_locales: E,
      id_token_hint: i,
      login_hint: n,
      acr_values: m,
      resource: d,
      request: t,
      request_uri: r,
      extraQueryParams: l,
      extraTokenParams: f,
      request_type: s,
      response_mode: k,
      client_secret: this.settings.client_secret,
      skipUserInfo: o,
      nonce: a,
      disablePKCE: this.settings.disablePKCE
    });
    await this.clearStaleState();
    const b = y.state;
    return await this.settings.stateStore.set(b.id, b.toStorageString()), y;
  }
  async readSigninResponseState(e, t = !1) {
    const r = this._logger.create("readSigninResponseState"), s = new he(Pe.readParams(e, this.settings.response_mode));
    if (!s.state)
      throw r.throw(new Error("No state in response")), null;
    const i = await this.settings.stateStore[t ? "remove" : "get"](s.state);
    if (!i)
      throw r.throw(new Error("No matching state found in storage")), null;
    return { state: He.fromStorageString(i), response: s };
  }
  async processSigninResponse(e) {
    const t = this._logger.create("processSigninResponse"), { state: r, response: s } = await this.readSigninResponseState(e, !0);
    return t.debug("received state from storage; validating response"), await this._validator.validateSigninResponse(s, r), s;
  }
  async processResourceOwnerPasswordCredentials({
    username: e,
    password: t,
    skipUserInfo: r = !1,
    extraTokenParams: s = {}
  }) {
    const i = await this._tokenClient.exchangeCredentials({ username: e, password: t, ...s }), n = new he(new URLSearchParams());
    return Object.assign(n, i), await this._validator.validateCredentialsResponse(n, r), n;
  }
  async useRefreshToken({
    state: e,
    timeoutInSeconds: t
  }) {
    var r;
    const s = this._logger.create("useRefreshToken");
    let i;
    if (this.settings.refreshTokenAllowedScope === void 0)
      i = e.scope;
    else {
      const a = this.settings.refreshTokenAllowedScope.split(" ");
      i = (((r = e.scope) == null ? void 0 : r.split(" ")) || []).filter((u) => a.includes(u)).join(" ");
    }
    const n = await this._tokenClient.exchangeRefreshToken({
      refresh_token: e.refresh_token,
      resource: e.resource,
      // provide the (possible filtered) scope list
      scope: i,
      timeoutInSeconds: t
    }), o = new he(new URLSearchParams());
    return Object.assign(o, n), s.debug("validating response", o), await this._validator.validateRefreshResponse(o, {
      ...e,
      // overide the scope in the state handed over to the validator
      // so it can set the granted scope to the requested scope in case none is included in the response
      scope: i
    }), o;
  }
  async createSignoutRequest({
    state: e,
    id_token_hint: t,
    client_id: r,
    request_type: s,
    post_logout_redirect_uri: i = this.settings.post_logout_redirect_uri,
    extraQueryParams: n = this.settings.extraQueryParams
  } = {}) {
    const o = this._logger.create("createSignoutRequest"), a = await this.metadataService.getEndSessionEndpoint();
    if (!a)
      throw o.throw(new Error("No end session endpoint")), null;
    o.debug("Received end session endpoint", a), !r && i && !t && (r = this.settings.client_id);
    const c = new qr({
      url: a,
      id_token_hint: t,
      client_id: r,
      post_logout_redirect_uri: i,
      state_data: e,
      extraQueryParams: n,
      request_type: s
    });
    await this.clearStaleState();
    const u = c.state;
    return u && (o.debug("Signout request has state to persist"), await this.settings.stateStore.set(u.id, u.toStorageString())), c;
  }
  async readSignoutResponseState(e, t = !1) {
    const r = this._logger.create("readSignoutResponseState"), s = new Nr(Pe.readParams(e, this.settings.response_mode));
    if (!s.state) {
      if (r.debug("No state in response"), s.error)
        throw r.warn("Response was error:", s.error), new z(s);
      return { state: void 0, response: s };
    }
    const i = await this.settings.stateStore[t ? "remove" : "get"](s.state);
    if (!i)
      throw r.throw(new Error("No matching state found in storage")), null;
    return { state: X.fromStorageString(i), response: s };
  }
  async processSignoutResponse(e) {
    const t = this._logger.create("processSignoutResponse"), { state: r, response: s } = await this.readSignoutResponseState(e, !0);
    return r ? (t.debug("Received state from storage; validating response"), this._validator.validateSignoutResponse(s, r)) : t.debug("No state from storage; skipping response validation"), s;
  }
  clearStaleState() {
    return this._logger.create("clearStaleState"), X.clearStaleState(this.settings.stateStore, this.settings.staleStateAgeInSeconds);
  }
  async revokeToken(e, t) {
    return this._logger.create("revokeToken"), await this._tokenClient.revoke({
      token: e,
      token_type_hint: t
    });
  }
}, Dr = class {
  constructor(e) {
    this._userManager = e, this._logger = new v("SessionMonitor"), this._start = async (t) => {
      const r = t.session_state;
      if (!r)
        return;
      const s = this._logger.create("_start");
      if (t.profile ? (this._sub = t.profile.sub, this._sid = t.profile.sid, s.debug("session_state", r, ", sub", this._sub)) : (this._sub = void 0, this._sid = void 0, s.debug("session_state", r, ", anonymous user")), this._checkSessionIFrame) {
        this._checkSessionIFrame.start(r);
        return;
      }
      try {
        const i = await this._userManager.metadataService.getCheckSessionIframe();
        if (i) {
          s.debug("initializing check session iframe");
          const n = this._userManager.settings.client_id, o = this._userManager.settings.checkSessionIntervalInSeconds, a = this._userManager.settings.stopCheckSessionOnError, c = new br(this._callback, n, i, o, a);
          await c.load(), this._checkSessionIFrame = c, c.start(r);
        } else
          s.warn("no check session iframe found in the metadata");
      } catch (i) {
        s.error("Error from getCheckSessionIframe:", i instanceof Error ? i.message : i);
      }
    }, this._stop = () => {
      const t = this._logger.create("_stop");
      if (this._sub = void 0, this._sid = void 0, this._checkSessionIFrame && this._checkSessionIFrame.stop(), this._userManager.settings.monitorAnonymousSession) {
        const r = setInterval(async () => {
          clearInterval(r);
          try {
            const s = await this._userManager.querySessionStatus();
            if (s) {
              const i = {
                session_state: s.session_state,
                profile: s.sub && s.sid ? {
                  sub: s.sub,
                  sid: s.sid
                } : null
              };
              this._start(i);
            }
          } catch (s) {
            t.error("error from querySessionStatus", s instanceof Error ? s.message : s);
          }
        }, 1e3);
      }
    }, this._callback = async () => {
      const t = this._logger.create("_callback");
      try {
        const r = await this._userManager.querySessionStatus();
        let s = !0;
        r && this._checkSessionIFrame ? r.sub === this._sub ? (s = !1, this._checkSessionIFrame.start(r.session_state), r.sid === this._sid ? t.debug("same sub still logged in at OP, restarting check session iframe; session_state", r.session_state) : (t.debug("same sub still logged in at OP, session state has changed, restarting check session iframe; session_state", r.session_state), this._userManager.events._raiseUserSessionChanged())) : t.debug("different subject signed into OP", r.sub) : t.debug("subject no longer signed into OP"), s ? this._sub ? this._userManager.events._raiseUserSignedOut() : this._userManager.events._raiseUserSignedIn() : t.debug("no change in session detected, no event to raise");
      } catch (r) {
        this._sub && (t.debug("Error calling queryCurrentSigninSession; raising signed out event", r), this._userManager.events._raiseUserSignedOut());
      }
    }, e || this._logger.throw(new Error("No user manager passed")), this._userManager.events.addUserLoaded(this._start), this._userManager.events.addUserUnloaded(this._stop), this._init().catch((t) => {
      this._logger.error(t);
    });
  }
  async _init() {
    this._logger.create("_init");
    const e = await this._userManager.getUser();
    if (e)
      this._start(e);
    else if (this._userManager.settings.monitorAnonymousSession) {
      const t = await this._userManager.querySessionStatus();
      if (t) {
        const r = {
          session_state: t.session_state,
          profile: t.sub && t.sid ? {
            sub: t.sub,
            sid: t.sid
          } : null
        };
        this._start(r);
      }
    }
  }
}, ee = class {
  constructor(e) {
    var t;
    this.id_token = e.id_token, this.session_state = (t = e.session_state) != null ? t : null, this.access_token = e.access_token, this.refresh_token = e.refresh_token, this.token_type = e.token_type, this.scope = e.scope, this.profile = e.profile, this.expires_at = e.expires_at, this.state = e.userState;
  }
  /** Computed number of seconds the access token has remaining. */
  get expires_in() {
    if (this.expires_at !== void 0)
      return this.expires_at - P.getEpochTime();
  }
  set expires_in(e) {
    e !== void 0 && (this.expires_at = Math.floor(e) + P.getEpochTime());
  }
  /** Computed value indicating if the access token is expired. */
  get expired() {
    const e = this.expires_in;
    if (e !== void 0)
      return e <= 0;
  }
  /** Array representing the parsed values from the `scope`. */
  get scopes() {
    var e, t;
    return (t = (e = this.scope) == null ? void 0 : e.split(" ")) != null ? t : [];
  }
  toStorageString() {
    return new v("User").create("toStorageString"), JSON.stringify({
      id_token: this.id_token,
      session_state: this.session_state,
      access_token: this.access_token,
      refresh_token: this.refresh_token,
      token_type: this.token_type,
      scope: this.scope,
      profile: this.profile,
      expires_at: this.expires_at
    });
  }
  static fromStorageString(e) {
    return v.createStatic("User", "fromStorageString"), new ee(JSON.parse(e));
  }
}, Ve = "oidc-client", Rt = class {
  constructor() {
    this._abort = new $("Window navigation aborted"), this._disposeHandlers = /* @__PURE__ */ new Set(), this._window = null;
  }
  async navigate(e) {
    const t = this._logger.create("navigate");
    if (!this._window)
      throw new Error("Attempted to navigate on a disposed window");
    t.debug("setting URL in window"), this._window.location.replace(e.url);
    const { url: r, keepOpen: s } = await new Promise((i, n) => {
      const o = (a) => {
        var c;
        const u = a.data, _ = (c = e.scriptOrigin) != null ? c : window.location.origin;
        if (!(a.origin !== _ || (u == null ? void 0 : u.source) !== Ve)) {
          try {
            const g = Pe.readParams(u.url, e.response_mode).get("state");
            if (g || t.warn("no state found in response url"), a.source !== this._window && g !== e.state)
              return;
          } catch {
            this._dispose(), n(new Error("Invalid response from window"));
          }
          i(u);
        }
      };
      window.addEventListener("message", o, !1), this._disposeHandlers.add(() => window.removeEventListener("message", o, !1)), this._disposeHandlers.add(this._abort.addHandler((a) => {
        this._dispose(), n(a);
      }));
    });
    return t.debug("got response from window"), this._dispose(), s || this.close(), { url: r };
  }
  _dispose() {
    this._logger.create("_dispose");
    for (const e of this._disposeHandlers)
      e();
    this._disposeHandlers.clear();
  }
  static _notifyParent(e, t, r = !1, s = window.location.origin) {
    e.postMessage({
      source: Ve,
      url: t,
      keepOpen: r
    }, s);
  }
}, It = {
  location: !1,
  toolbar: !1,
  height: 640
}, At = "_blank", $r = 60, Lr = 2, Pt = 10, Fr = class extends Ue {
  constructor(e) {
    const {
      popup_redirect_uri: t = e.redirect_uri,
      popup_post_logout_redirect_uri: r = e.post_logout_redirect_uri,
      popupWindowFeatures: s = It,
      popupWindowTarget: i = At,
      redirectMethod: n = "assign",
      redirectTarget: o = "self",
      iframeNotifyParentOrigin: a = e.iframeNotifyParentOrigin,
      iframeScriptOrigin: c = e.iframeScriptOrigin,
      silent_redirect_uri: u = e.redirect_uri,
      silentRequestTimeoutInSeconds: _ = Pt,
      automaticSilentRenew: g = !0,
      validateSubOnSilentRenew: p = !0,
      includeIdTokenInSilentRenew: h = !1,
      monitorSession: E = !1,
      monitorAnonymousSession: m = !1,
      checkSessionIntervalInSeconds: d = Lr,
      query_status_response_type: k = "code",
      stopCheckSessionOnError: l = !0,
      revokeTokenTypes: f = ["access_token", "refresh_token"],
      revokeTokensOnSignout: w = !1,
      includeIdTokenInSilentSignout: S = !1,
      accessTokenExpiringNotificationTimeInSeconds: y = $r,
      userStore: b
    } = e;
    if (super(e), this.popup_redirect_uri = t, this.popup_post_logout_redirect_uri = r, this.popupWindowFeatures = s, this.popupWindowTarget = i, this.redirectMethod = n, this.redirectTarget = o, this.iframeNotifyParentOrigin = a, this.iframeScriptOrigin = c, this.silent_redirect_uri = u, this.silentRequestTimeoutInSeconds = _, this.automaticSilentRenew = g, this.validateSubOnSilentRenew = p, this.includeIdTokenInSilentRenew = h, this.monitorSession = E, this.monitorAnonymousSession = m, this.checkSessionIntervalInSeconds = d, this.stopCheckSessionOnError = l, this.query_status_response_type = k, this.revokeTokenTypes = f, this.revokeTokensOnSignout = w, this.includeIdTokenInSilentSignout = S, this.accessTokenExpiringNotificationTimeInSeconds = y, b)
      this.userStore = b;
    else {
      const C = typeof window < "u" ? window.sessionStorage : new Ct();
      this.userStore = new xt({ store: C });
    }
  }
}, Oe = class extends Rt {
  constructor({
    silentRequestTimeoutInSeconds: e = Pt
  }) {
    super(), this._logger = new v("IFrameWindow"), this._timeoutInSeconds = e, this._frame = Oe.createHiddenIframe(), this._window = this._frame.contentWindow;
  }
  static createHiddenIframe() {
    const e = window.document.createElement("iframe");
    return e.style.visibility = "hidden", e.style.position = "fixed", e.style.left = "-1000px", e.style.top = "0", e.width = "0", e.height = "0", window.document.body.appendChild(e), e;
  }
  async navigate(e) {
    this._logger.debug("navigate: Using timeout of:", this._timeoutInSeconds);
    const t = setTimeout(() => this._abort.raise(new Me("IFrame timed out without a response")), this._timeoutInSeconds * 1e3);
    return this._disposeHandlers.add(() => clearTimeout(t)), await super.navigate(e);
  }
  close() {
    var e;
    this._frame && (this._frame.parentNode && (this._frame.addEventListener("load", (t) => {
      var r;
      const s = t.target;
      (r = s.parentNode) == null || r.removeChild(s), this._abort.raise(new Error("IFrame removed from DOM"));
    }, !0), (e = this._frame.contentWindow) == null || e.location.replace("about:blank")), this._frame = null), this._window = null;
  }
  static notifyParent(e, t) {
    return super._notifyParent(window.parent, e, !1, t);
  }
}, Wr = class {
  constructor(e) {
    this._settings = e, this._logger = new v("IFrameNavigator");
  }
  async prepare({
    silentRequestTimeoutInSeconds: e = this._settings.silentRequestTimeoutInSeconds
  }) {
    return new Oe({ silentRequestTimeoutInSeconds: e });
  }
  async callback(e) {
    this._logger.create("callback"), Oe.notifyParent(e, this._settings.iframeNotifyParentOrigin);
  }
}, zr = 500, Xe = class extends Rt {
  constructor({
    popupWindowTarget: e = At,
    popupWindowFeatures: t = {}
  }) {
    super(), this._logger = new v("PopupWindow");
    const r = Ke.center({ ...It, ...t });
    this._window = window.open(void 0, e, Ke.serialize(r));
  }
  async navigate(e) {
    var t;
    (t = this._window) == null || t.focus();
    const r = setInterval(() => {
      (!this._window || this._window.closed) && this._abort.raise(new Error("Popup closed by user"));
    }, zr);
    return this._disposeHandlers.add(() => clearInterval(r)), await super.navigate(e);
  }
  close() {
    this._window && (this._window.closed || (this._window.close(), this._abort.raise(new Error("Popup closed")))), this._window = null;
  }
  static notifyOpener(e, t) {
    if (!window.opener)
      throw new Error("No window.opener. Can't complete notification.");
    return super._notifyParent(window.opener, e, t);
  }
}, Jr = class {
  constructor(e) {
    this._settings = e, this._logger = new v("PopupNavigator");
  }
  async prepare({
    popupWindowFeatures: e = this._settings.popupWindowFeatures,
    popupWindowTarget: t = this._settings.popupWindowTarget
  }) {
    return new Xe({ popupWindowFeatures: e, popupWindowTarget: t });
  }
  async callback(e, t = !1) {
    this._logger.create("callback"), Xe.notifyOpener(e, t);
  }
}, Kr = class {
  constructor(e) {
    this._settings = e, this._logger = new v("RedirectNavigator");
  }
  async prepare({
    redirectMethod: e = this._settings.redirectMethod,
    redirectTarget: t = this._settings.redirectTarget
  }) {
    var r;
    this._logger.create("prepare");
    let s = window.self;
    t === "top" && (s = (r = window.top) != null ? r : window.self);
    const i = s.location[e].bind(s.location);
    let n;
    return {
      navigate: async (o) => {
        this._logger.create("navigate");
        const a = new Promise((c, u) => {
          n = u;
        });
        return i(o.url), await a;
      },
      close: () => {
        this._logger.create("close"), n == null || n(new Error("Redirect aborted")), s.stop();
      }
    };
  }
}, Vr = class extends yr {
  constructor(e) {
    super({ expiringNotificationTimeInSeconds: e.accessTokenExpiringNotificationTimeInSeconds }), this._logger = new v("UserManagerEvents"), this._userLoaded = new $("User loaded"), this._userUnloaded = new $("User unloaded"), this._silentRenewError = new $("Silent renew error"), this._userSignedIn = new $("User signed in"), this._userSignedOut = new $("User signed out"), this._userSessionChanged = new $("User session changed");
  }
  load(e, t = !0) {
    super.load(e), t && this._userLoaded.raise(e);
  }
  unload() {
    super.unload(), this._userUnloaded.raise();
  }
  /**
   * Add callback: Raised when a user session has been established (or re-established).
   */
  addUserLoaded(e) {
    return this._userLoaded.addHandler(e);
  }
  /**
   * Remove callback: Raised when a user session has been established (or re-established).
   */
  removeUserLoaded(e) {
    return this._userLoaded.removeHandler(e);
  }
  /**
   * Add callback: Raised when a user session has been terminated.
   */
  addUserUnloaded(e) {
    return this._userUnloaded.addHandler(e);
  }
  /**
   * Remove callback: Raised when a user session has been terminated.
   */
  removeUserUnloaded(e) {
    return this._userUnloaded.removeHandler(e);
  }
  /**
   * Add callback: Raised when the automatic silent renew has failed.
   */
  addSilentRenewError(e) {
    return this._silentRenewError.addHandler(e);
  }
  /**
   * Remove callback: Raised when the automatic silent renew has failed.
   */
  removeSilentRenewError(e) {
    return this._silentRenewError.removeHandler(e);
  }
  /**
   * @internal
   */
  _raiseSilentRenewError(e) {
    this._silentRenewError.raise(e);
  }
  /**
   * Add callback: Raised when the user is signed in (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */
  addUserSignedIn(e) {
    return this._userSignedIn.addHandler(e);
  }
  /**
   * Remove callback: Raised when the user is signed in (when `monitorSession` is set).
   */
  removeUserSignedIn(e) {
    this._userSignedIn.removeHandler(e);
  }
  /**
   * @internal
   */
  _raiseUserSignedIn() {
    this._userSignedIn.raise();
  }
  /**
   * Add callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */
  addUserSignedOut(e) {
    return this._userSignedOut.addHandler(e);
  }
  /**
   * Remove callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   */
  removeUserSignedOut(e) {
    this._userSignedOut.removeHandler(e);
  }
  /**
   * @internal
   */
  _raiseUserSignedOut() {
    this._userSignedOut.raise();
  }
  /**
   * Add callback: Raised when the user session changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */
  addUserSessionChanged(e) {
    return this._userSessionChanged.addHandler(e);
  }
  /**
   * Remove callback: Raised when the user session changed (when `monitorSession` is set).
   */
  removeUserSessionChanged(e) {
    this._userSessionChanged.removeHandler(e);
  }
  /**
   * @internal
   */
  _raiseUserSessionChanged() {
    this._userSessionChanged.raise();
  }
}, Xr = class {
  constructor(e) {
    this._userManager = e, this._logger = new v("SilentRenewService"), this._isStarted = !1, this._retryTimer = new P("Retry Silent Renew"), this._tokenExpiring = async () => {
      const t = this._logger.create("_tokenExpiring");
      try {
        await this._userManager.signinSilent(), t.debug("silent token renewal successful");
      } catch (r) {
        if (r instanceof Me) {
          t.warn("ErrorTimeout from signinSilent:", r, "retry in 5s"), this._retryTimer.init(5);
          return;
        }
        t.error("Error from signinSilent:", r), this._userManager.events._raiseSilentRenewError(r);
      }
    };
  }
  async start() {
    const e = this._logger.create("start");
    if (!this._isStarted) {
      this._isStarted = !0, this._userManager.events.addAccessTokenExpiring(this._tokenExpiring), this._retryTimer.addHandler(this._tokenExpiring);
      try {
        await this._userManager.getUser();
      } catch (t) {
        e.error("getUser error", t);
      }
    }
  }
  stop() {
    this._isStarted && (this._retryTimer.cancel(), this._retryTimer.removeHandler(this._tokenExpiring), this._userManager.events.removeAccessTokenExpiring(this._tokenExpiring), this._isStarted = !1);
  }
}, Gr = class {
  constructor(e, t) {
    this.refresh_token = e.refresh_token, this.id_token = e.id_token, this.session_state = e.session_state, this.scope = e.scope, this.profile = e.profile, this.resource = t, this.data = e.state;
  }
}, Yr = class {
  constructor(e) {
    this._logger = new v("UserManager"), this.settings = new Fr(e), this._client = new Br(e), this._redirectNavigator = new Kr(this.settings), this._popupNavigator = new Jr(this.settings), this._iframeNavigator = new Wr(this.settings), this._events = new Vr(this.settings), this._silentRenewService = new Xr(this), this.settings.automaticSilentRenew && this.startSilentRenew(), this._sessionMonitor = null, this.settings.monitorSession && (this._sessionMonitor = new Dr(this));
  }
  /** Returns an object used to register for events raised by the `UserManager`. */
  get events() {
    return this._events;
  }
  /** Returns an object used to access the metadata configuration of the OIDC provider. */
  get metadataService() {
    return this._client.metadataService;
  }
  /**
   * Returns promise to load the `User` object for the currently authenticated user.
   */
  async getUser() {
    const e = this._logger.create("getUser"), t = await this._loadUser();
    return t ? (e.info("user loaded"), this._events.load(t, !1), t) : (e.info("user not found in storage"), null);
  }
  /**
   * Returns promise to remove from any storage the currently authenticated user.
   */
  async removeUser() {
    const e = this._logger.create("removeUser");
    await this.storeUser(null), e.info("user removed from storage"), this._events.unload();
  }
  /**
   * Returns promise to trigger a redirect of the current window to the authorization endpoint.
   */
  async signinRedirect(e = {}) {
    this._logger.create("signinRedirect");
    const {
      redirectMethod: t,
      ...r
    } = e, s = await this._redirectNavigator.prepare({ redirectMethod: t });
    await this._signinStart({
      request_type: "si:r",
      ...r
    }, s);
  }
  /**
   * Returns promise to process response from the authorization endpoint. The result of the promise is the authenticated `User`.
   */
  async signinRedirectCallback(e = window.location.href) {
    const t = this._logger.create("signinRedirectCallback"), r = await this._signinEnd(e);
    return r.profile && r.profile.sub ? t.info("success, signed in subject", r.profile.sub) : t.info("no subject"), r;
  }
  /**
   * Returns promise to process the signin with user/password. The result of the promise is the authenticated `User`.
   *
   * Throws an ErrorResponse in case of wrong authentication.
   */
  async signinResourceOwnerCredentials({
    username: e,
    password: t,
    skipUserInfo: r = !1
  }) {
    const s = this._logger.create("signinResourceOwnerCredential"), i = await this._client.processResourceOwnerPasswordCredentials({ username: e, password: t, skipUserInfo: r, extraTokenParams: this.settings.extraTokenParams });
    s.debug("got signin response");
    const n = await this._buildUser(i);
    return n.profile && n.profile.sub ? s.info("success, signed in subject", n.profile.sub) : s.info("no subject"), n;
  }
  /**
   * Returns promise to trigger a request (via a popup window) to the authorization endpoint. The result of the promise is the authenticated `User`.
   */
  async signinPopup(e = {}) {
    const t = this._logger.create("signinPopup"), {
      popupWindowFeatures: r,
      popupWindowTarget: s,
      ...i
    } = e, n = this.settings.popup_redirect_uri;
    n || t.throw(new Error("No popup_redirect_uri configured"));
    const o = await this._popupNavigator.prepare({ popupWindowFeatures: r, popupWindowTarget: s }), a = await this._signin({
      request_type: "si:p",
      redirect_uri: n,
      display: "popup",
      ...i
    }, o);
    return a && (a.profile && a.profile.sub ? t.info("success, signed in subject", a.profile.sub) : t.info("no subject")), a;
  }
  /**
   * Returns promise to notify the opening window of response from the authorization endpoint.
   */
  async signinPopupCallback(e = window.location.href, t = !1) {
    const r = this._logger.create("signinPopupCallback");
    await this._popupNavigator.callback(e, t), r.info("success");
  }
  /**
   * Returns promise to trigger a silent request (via an iframe) to the authorization endpoint.
   * The result of the promise is the authenticated `User`.
   */
  async signinSilent(e = {}) {
    var t;
    const r = this._logger.create("signinSilent"), {
      silentRequestTimeoutInSeconds: s,
      resource: i,
      ...n
    } = e;
    let o = await this._loadUser();
    if (o != null && o.refresh_token) {
      r.debug("using refresh token");
      const _ = new Gr(o, i);
      return await this._useRefreshToken(_);
    }
    const a = this.settings.silent_redirect_uri;
    a || r.throw(new Error("No silent_redirect_uri configured"));
    let c;
    o && this.settings.validateSubOnSilentRenew && (r.debug("subject prior to silent renew:", o.profile.sub), c = o.profile.sub);
    const u = await this._iframeNavigator.prepare({ silentRequestTimeoutInSeconds: s });
    return o = await this._signin({
      request_type: "si:s",
      redirect_uri: a,
      prompt: "none",
      id_token_hint: this.settings.includeIdTokenInSilentRenew ? o == null ? void 0 : o.id_token : void 0,
      ...n
    }, u, c), o && ((t = o.profile) != null && t.sub ? r.info("success, signed in subject", o.profile.sub) : r.info("no subject")), o;
  }
  async _useRefreshToken(e) {
    const t = await this._client.useRefreshToken({
      state: e,
      timeoutInSeconds: this.settings.silentRequestTimeoutInSeconds
    }), r = new ee({ ...e, ...t });
    return await this.storeUser(r), this._events.load(r), r;
  }
  /**
   * Returns promise to notify the parent window of response from the authorization endpoint.
   */
  async signinSilentCallback(e = window.location.href) {
    const t = this._logger.create("signinSilentCallback");
    await this._iframeNavigator.callback(e), t.info("success");
  }
  async signinCallback(e = window.location.href) {
    const { state: t } = await this._client.readSigninResponseState(e);
    switch (t.request_type) {
      case "si:r":
        return await this.signinRedirectCallback(e);
      case "si:p":
        return await this.signinPopupCallback(e);
      case "si:s":
        return await this.signinSilentCallback(e);
      default:
        throw new Error("invalid response_type in state");
    }
  }
  async signoutCallback(e = window.location.href, t = !1) {
    const { state: r } = await this._client.readSignoutResponseState(e);
    if (r)
      switch (r.request_type) {
        case "so:r":
          await this.signoutRedirectCallback(e);
          break;
        case "so:p":
          await this.signoutPopupCallback(e, t);
          break;
        case "so:s":
          await this.signoutSilentCallback(e);
          break;
        default:
          throw new Error("invalid response_type in state");
      }
  }
  /**
   * Returns promise to query OP for user's current signin status. Returns object with session_state and subject identifier.
   */
  async querySessionStatus(e = {}) {
    const t = this._logger.create("querySessionStatus"), {
      silentRequestTimeoutInSeconds: r,
      ...s
    } = e, i = this.settings.silent_redirect_uri;
    i || t.throw(new Error("No silent_redirect_uri configured"));
    const n = await this._loadUser(), o = await this._iframeNavigator.prepare({ silentRequestTimeoutInSeconds: r }), a = await this._signinStart({
      request_type: "si:s",
      // this acts like a signin silent
      redirect_uri: i,
      prompt: "none",
      id_token_hint: this.settings.includeIdTokenInSilentRenew ? n == null ? void 0 : n.id_token : void 0,
      response_type: this.settings.query_status_response_type,
      scope: "openid",
      skipUserInfo: !0,
      ...s
    }, o);
    try {
      const c = await this._client.processSigninResponse(a.url);
      return t.debug("got signin response"), c.session_state && c.profile.sub ? (t.info("success for subject", c.profile.sub), {
        session_state: c.session_state,
        sub: c.profile.sub,
        sid: c.profile.sid
      }) : (t.info("success, user not authenticated"), null);
    } catch (c) {
      if (this.settings.monitorAnonymousSession && c instanceof z)
        switch (c.error) {
          case "login_required":
          case "consent_required":
          case "interaction_required":
          case "account_selection_required":
            return t.info("success for anonymous user"), {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              session_state: c.session_state
            };
        }
      throw c;
    }
  }
  async _signin(e, t, r) {
    const s = await this._signinStart(e, t);
    return await this._signinEnd(s.url, r);
  }
  async _signinStart(e, t) {
    const r = this._logger.create("_signinStart");
    try {
      const s = await this._client.createSigninRequest(e);
      return r.debug("got signin request"), await t.navigate({
        url: s.url,
        state: s.state.id,
        response_mode: s.state.response_mode,
        scriptOrigin: this.settings.iframeScriptOrigin
      });
    } catch (s) {
      throw r.debug("error after preparing navigator, closing navigator window"), t.close(), s;
    }
  }
  async _signinEnd(e, t) {
    const r = this._logger.create("_signinEnd"), s = await this._client.processSigninResponse(e);
    return r.debug("got signin response"), await this._buildUser(s, t);
  }
  async _buildUser(e, t) {
    const r = this._logger.create("_buildUser"), s = new ee(e);
    if (t) {
      if (t !== s.profile.sub)
        throw r.debug("current user does not match user returned from signin. sub from signin:", s.profile.sub), new z({ ...e, error: "login_required" });
      r.debug("current user matches user returned from signin");
    }
    return await this.storeUser(s), r.debug("user stored"), this._events.load(s), s;
  }
  /**
   * Returns promise to trigger a redirect of the current window to the end session endpoint.
   */
  async signoutRedirect(e = {}) {
    const t = this._logger.create("signoutRedirect"), {
      redirectMethod: r,
      ...s
    } = e, i = await this._redirectNavigator.prepare({ redirectMethod: r });
    await this._signoutStart({
      request_type: "so:r",
      post_logout_redirect_uri: this.settings.post_logout_redirect_uri,
      ...s
    }, i), t.info("success");
  }
  /**
   * Returns promise to process response from the end session endpoint.
   */
  async signoutRedirectCallback(e = window.location.href) {
    const t = this._logger.create("signoutRedirectCallback"), r = await this._signoutEnd(e);
    return t.info("success"), r;
  }
  /**
   * Returns promise to trigger a redirect of a popup window window to the end session endpoint.
   */
  async signoutPopup(e = {}) {
    const t = this._logger.create("signoutPopup"), {
      popupWindowFeatures: r,
      popupWindowTarget: s,
      ...i
    } = e, n = this.settings.popup_post_logout_redirect_uri, o = await this._popupNavigator.prepare({ popupWindowFeatures: r, popupWindowTarget: s });
    await this._signout({
      request_type: "so:p",
      post_logout_redirect_uri: n,
      // we're putting a dummy entry in here because we
      // need a unique id from the state for notification
      // to the parent window, which is necessary if we
      // plan to return back to the client after signout
      // and so we can close the popup after signout
      state: n == null ? void 0 : {},
      ...i
    }, o), t.info("success");
  }
  /**
   * Returns promise to process response from the end session endpoint from a popup window.
   */
  async signoutPopupCallback(e = window.location.href, t = !1) {
    const r = this._logger.create("signoutPopupCallback");
    await this._popupNavigator.callback(e, t), r.info("success");
  }
  async _signout(e, t) {
    const r = await this._signoutStart(e, t);
    return await this._signoutEnd(r.url);
  }
  async _signoutStart(e = {}, t) {
    var r;
    const s = this._logger.create("_signoutStart");
    try {
      const i = await this._loadUser();
      s.debug("loaded current user from storage"), this.settings.revokeTokensOnSignout && await this._revokeInternal(i);
      const n = e.id_token_hint || i && i.id_token;
      n && (s.debug("setting id_token_hint in signout request"), e.id_token_hint = n), await this.removeUser(), s.debug("user removed, creating signout request");
      const o = await this._client.createSignoutRequest(e);
      return s.debug("got signout request"), await t.navigate({
        url: o.url,
        state: (r = o.state) == null ? void 0 : r.id
      });
    } catch (i) {
      throw s.debug("error after preparing navigator, closing navigator window"), t.close(), i;
    }
  }
  async _signoutEnd(e) {
    const t = this._logger.create("_signoutEnd"), r = await this._client.processSignoutResponse(e);
    return t.debug("got signout response"), r;
  }
  /**
   * Returns promise to trigger a silent request (via an iframe) to the end session endpoint.
   */
  async signoutSilent(e = {}) {
    var t;
    const r = this._logger.create("signoutSilent"), {
      silentRequestTimeoutInSeconds: s,
      ...i
    } = e, n = this.settings.includeIdTokenInSilentSignout ? (t = await this._loadUser()) == null ? void 0 : t.id_token : void 0, o = this.settings.popup_post_logout_redirect_uri, a = await this._iframeNavigator.prepare({ silentRequestTimeoutInSeconds: s });
    await this._signout({
      request_type: "so:s",
      post_logout_redirect_uri: o,
      id_token_hint: n,
      ...i
    }, a), r.info("success");
  }
  /**
   * Returns promise to notify the parent window of response from the end session endpoint.
   */
  async signoutSilentCallback(e = window.location.href) {
    const t = this._logger.create("signoutSilentCallback");
    await this._iframeNavigator.callback(e), t.info("success");
  }
  async revokeTokens(e) {
    const t = await this._loadUser();
    await this._revokeInternal(t, e);
  }
  async _revokeInternal(e, t = this.settings.revokeTokenTypes) {
    const r = this._logger.create("_revokeInternal");
    if (!e)
      return;
    const s = t.filter((i) => typeof e[i] == "string");
    if (!s.length) {
      r.debug("no need to revoke due to no token(s)");
      return;
    }
    for (const i of s)
      await this._client.revokeToken(
        e[i],
        // eslint-disable-line @typescript-eslint/no-non-null-assertion
        i
      ), r.info(`${i} revoked successfully`), i !== "access_token" && (e[i] = null);
    await this.storeUser(e), r.debug("user stored"), this._events.load(e);
  }
  /**
   * Enables silent renew for the `UserManager`.
   */
  startSilentRenew() {
    this._logger.create("startSilentRenew"), this._silentRenewService.start();
  }
  /**
   * Disables silent renew for the `UserManager`.
   */
  stopSilentRenew() {
    this._silentRenewService.stop();
  }
  get _userStoreKey() {
    return `user:${this.settings.authority}:${this.settings.client_id}`;
  }
  async _loadUser() {
    const e = this._logger.create("_loadUser"), t = await this.settings.userStore.get(this._userStoreKey);
    return t ? (e.debug("user storageString loaded"), ee.fromStorageString(t)) : (e.debug("no user storageString"), null);
  }
  async storeUser(e) {
    const t = this._logger.create("storeUser");
    if (e) {
      t.debug("storing user");
      const r = e.toStorageString();
      await this.settings.userStore.set(this._userStoreKey, r);
    } else
      this._logger.debug("removing user"), await this.settings.userStore.remove(this._userStoreKey);
  }
  /**
   * Removes stale state entries in storage for incomplete authorize requests.
   */
  async clearStaleState() {
    await this._client.clearStaleState();
  }
};
W.setLevel(W.ERROR);
W.setLogger({
  error(e) {
    console.error(e);
  },
  info(e) {
    console.error(e);
  },
  debug(e) {
    console.error(e);
  },
  warn(e) {
    console.error(e);
  }
});
const D = {
  stsAuthority: `${window.env.RHSSO_URL}realms/${window.env.RHSSO_REALM}/`,
  clientId: window.env.RHSSO_CLIENT,
  clientRoot: window.location.origin + "/@service-portal/container/",
  clientScope: "openid profile email api roles",
  apiRoot: window.env.RHSSO_URL
}, N = class N {
  constructor() {
    B(this, "_userManager");
    B(this, "_userPromise");
    B(this, "sessionRealmName");
    this.sessionRealmName = D.clientId, this._userManager = this._initUserManager(), this.sessionRealmName ? this._userPromise = this._signIn() : (this._userManager.removeUser(), this._userPromise = Promise.resolve(null));
  }
  _initUserManager() {
    return new Yr({
      authority: D.stsAuthority,
      client_id: D.clientId,
      monitorSession: !1,
      filterProtocolClaims: !1,
      loadUserInfo: !1,
      post_logout_redirect_uri: document.location.href,
      redirect_uri: `${D.clientRoot}manager.html?redirect=${encodeURIComponent(document.location.href)}`,
      automaticSilentRenew: !1,
      silent_redirect_uri: `${D.clientRoot}silent.html`,
      response_type: "code",
      scope: D.clientScope,
      clockSkewInSeconds: 60 * 60 * 24 * 30,
      // 30 days. Same as disabling JWT time checks that are not needed client side.
      accessTokenExpiringNotificationTimeInSeconds: N.accessTokenExpiringNotificationTime,
      includeIdTokenInSilentRenew: !0
    });
  }
  // first signin try
  async _signIn() {
    const t = await this._userManager.getUser();
    return t && N._hasValidToken(t) ? t : this._userManager.signinSilent().catch(() => this._removeUserAndSignIn());
  }
  // second signin try:
  // remove user from store and try silent signin again
  async _removeUserAndSignIn() {
    return await this._userManager.removeUser(), this._userManager.signinSilent().catch((t) => {
      throw console.error(t), this.logout(document.location.href), t;
    });
  }
  static _hasValidToken(t) {
    return t.expires_in !== void 0 && t.expires_in > N.accessTokenExpiringNotificationTime;
  }
  _getRealm() {
    return this.sessionRealmName || D.stsAuthority;
  }
  hasLoggedStatus() {
    return this.sessionRealmName != null;
  }
  getUser() {
    return this._userPromise = this._userPromise.then((t) => t ? N._hasValidToken(t) ? t : this._signIn() : null), this._userPromise;
  }
  reloadUser() {
    return this._userPromise = this._removeUserAndSignIn(), this._userPromise;
  }
  static prefixOrigin(t) {
    return /^http/.test(t) ? t : N.getOrigin() + t;
  }
  static getOrigin() {
    let t = window.location.origin;
    return t || (t = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "")), t;
  }
  changePassword(t = "") {
    let r = "";
    t && (r = `?redirect_uri=${encodeURIComponent(N.prefixOrigin(t))}`), document.location.href = `${D.stsAuthority}account/password${r}`;
  }
  login(t) {
    return this._userManager.signinRedirect({
      redirect_uri: t ? N.prefixOrigin(t) : void 0
    });
  }
  async logout(t = "") {
    await this._userManager.removeUser(), document.location.href = t;
  }
  isAuthenticated() {
    return new Promise((t) => {
      this._userPromise.then((r) => {
        t(!!r);
      }).catch(() => {
        t(!1);
      });
    });
  }
  async hasRoles(t) {
    if (await this.isAuthenticated()) {
      const r = await this.getUserRoles();
      return t.some((s) => r.includes(s));
    }
    return !1;
  }
  async getUserRoles() {
    var t, r;
    if (await this.isAuthenticated()) {
      const s = await this.getUser();
      return ((r = (t = s == null ? void 0 : s.profile) == null ? void 0 : t.realm_access) == null ? void 0 : r.roles) ?? [];
    }
    return [];
  }
};
B(N, "accessTokenExpiringNotificationTime", 60);
let Ge = N;
var Be = { exports: {} }, Ut = function(t, r) {
  return function() {
    for (var i = new Array(arguments.length), n = 0; n < i.length; n++)
      i[n] = arguments[n];
    return t.apply(r, i);
  };
}, Qr = Ut, J = Object.prototype.toString;
function De(e) {
  return J.call(e) === "[object Array]";
}
function qe(e) {
  return typeof e > "u";
}
function Zr(e) {
  return e !== null && !qe(e) && e.constructor !== null && !qe(e.constructor) && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function es(e) {
  return J.call(e) === "[object ArrayBuffer]";
}
function ts(e) {
  return typeof FormData < "u" && e instanceof FormData;
}
function rs(e) {
  var t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && e.buffer instanceof ArrayBuffer, t;
}
function ss(e) {
  return typeof e == "string";
}
function is(e) {
  return typeof e == "number";
}
function Ot(e) {
  return e !== null && typeof e == "object";
}
function te(e) {
  if (J.call(e) !== "[object Object]")
    return !1;
  var t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}
function ns(e) {
  return J.call(e) === "[object Date]";
}
function os(e) {
  return J.call(e) === "[object File]";
}
function as(e) {
  return J.call(e) === "[object Blob]";
}
function qt(e) {
  return J.call(e) === "[object Function]";
}
function cs(e) {
  return Ot(e) && qt(e.pipe);
}
function us(e) {
  return typeof URLSearchParams < "u" && e instanceof URLSearchParams;
}
function ls(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function ds() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function $e(e, t) {
  if (!(e === null || typeof e > "u"))
    if (typeof e != "object" && (e = [e]), De(e))
      for (var r = 0, s = e.length; r < s; r++)
        t.call(null, e[r], r, e);
    else
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && t.call(null, e[i], i, e);
}
function Ne() {
  var e = {};
  function t(i, n) {
    te(e[n]) && te(i) ? e[n] = Ne(e[n], i) : te(i) ? e[n] = Ne({}, i) : De(i) ? e[n] = i.slice() : e[n] = i;
  }
  for (var r = 0, s = arguments.length; r < s; r++)
    $e(arguments[r], t);
  return e;
}
function hs(e, t, r) {
  return $e(t, function(i, n) {
    r && typeof i == "function" ? e[n] = Qr(i, r) : e[n] = i;
  }), e;
}
function gs(e) {
  return e.charCodeAt(0) === 65279 && (e = e.slice(1)), e;
}
var I = {
  isArray: De,
  isArrayBuffer: es,
  isBuffer: Zr,
  isFormData: ts,
  isArrayBufferView: rs,
  isString: ss,
  isNumber: is,
  isObject: Ot,
  isPlainObject: te,
  isUndefined: qe,
  isDate: ns,
  isFile: os,
  isBlob: as,
  isFunction: qt,
  isStream: cs,
  isURLSearchParams: us,
  isStandardBrowserEnv: ds,
  forEach: $e,
  merge: Ne,
  extend: hs,
  trim: ls,
  stripBOM: gs
}, K = I;
function Ye(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var Nt = function(t, r, s) {
  if (!r)
    return t;
  var i;
  if (s)
    i = s(r);
  else if (K.isURLSearchParams(r))
    i = r.toString();
  else {
    var n = [];
    K.forEach(r, function(c, u) {
      c === null || typeof c > "u" || (K.isArray(c) ? u = u + "[]" : c = [c], K.forEach(c, function(g) {
        K.isDate(g) ? g = g.toISOString() : K.isObject(g) && (g = JSON.stringify(g)), n.push(Ye(u) + "=" + Ye(g));
      }));
    }), i = n.join("&");
  }
  if (i) {
    var o = t.indexOf("#");
    o !== -1 && (t = t.slice(0, o)), t += (t.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return t;
}, fs = I;
function ne() {
  this.handlers = [];
}
ne.prototype.use = function(t, r, s) {
  return this.handlers.push({
    fulfilled: t,
    rejected: r,
    synchronous: s ? s.synchronous : !1,
    runWhen: s ? s.runWhen : null
  }), this.handlers.length - 1;
};
ne.prototype.eject = function(t) {
  this.handlers[t] && (this.handlers[t] = null);
};
ne.prototype.forEach = function(t) {
  fs.forEach(this.handlers, function(s) {
    s !== null && t(s);
  });
};
var ps = ne, _s = I, ms = function(t, r) {
  _s.forEach(t, function(i, n) {
    n !== r && n.toUpperCase() === r.toUpperCase() && (t[r] = i, delete t[n]);
  });
}, Mt = function(t, r, s, i, n) {
  return t.config = r, s && (t.code = s), t.request = i, t.response = n, t.isAxiosError = !0, t.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  }, t;
}, ge, Qe;
function jt() {
  if (Qe)
    return ge;
  Qe = 1;
  var e = Mt;
  return ge = function(r, s, i, n, o) {
    var a = new Error(r);
    return e(a, s, i, n, o);
  }, ge;
}
var fe, Ze;
function ws() {
  if (Ze)
    return fe;
  Ze = 1;
  var e = jt();
  return fe = function(r, s, i) {
    var n = i.config.validateStatus;
    !i.status || !n || n(i.status) ? r(i) : s(e(
      "Request failed with status code " + i.status,
      i.config,
      null,
      i.request,
      i
    ));
  }, fe;
}
var pe, et;
function vs() {
  if (et)
    return pe;
  et = 1;
  var e = I;
  return pe = e.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    function() {
      return {
        write: function(s, i, n, o, a, c) {
          var u = [];
          u.push(s + "=" + encodeURIComponent(i)), e.isNumber(n) && u.push("expires=" + new Date(n).toGMTString()), e.isString(o) && u.push("path=" + o), e.isString(a) && u.push("domain=" + a), c === !0 && u.push("secure"), document.cookie = u.join("; ");
        },
        read: function(s) {
          var i = document.cookie.match(new RegExp("(^|;\\s*)(" + s + ")=([^;]*)"));
          return i ? decodeURIComponent(i[3]) : null;
        },
        remove: function(s) {
          this.write(s, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), pe;
}
var _e, tt;
function Ss() {
  return tt || (tt = 1, _e = function(t) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(t);
  }), _e;
}
var me, rt;
function ys() {
  return rt || (rt = 1, me = function(t, r) {
    return r ? t.replace(/\/+$/, "") + "/" + r.replace(/^\/+/, "") : t;
  }), me;
}
var we, st;
function bs() {
  if (st)
    return we;
  st = 1;
  var e = Ss(), t = ys();
  return we = function(s, i) {
    return s && !e(i) ? t(s, i) : i;
  }, we;
}
var ve, it;
function ks() {
  if (it)
    return ve;
  it = 1;
  var e = I, t = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return ve = function(s) {
    var i = {}, n, o, a;
    return s && e.forEach(s.split(`
`), function(u) {
      if (a = u.indexOf(":"), n = e.trim(u.substr(0, a)).toLowerCase(), o = e.trim(u.substr(a + 1)), n) {
        if (i[n] && t.indexOf(n) >= 0)
          return;
        n === "set-cookie" ? i[n] = (i[n] ? i[n] : []).concat([o]) : i[n] = i[n] ? i[n] + ", " + o : o;
      }
    }), i;
  }, ve;
}
var Se, nt;
function Es() {
  if (nt)
    return Se;
  nt = 1;
  var e = I;
  return Se = e.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var r = /(msie|trident)/i.test(navigator.userAgent), s = document.createElement("a"), i;
      function n(o) {
        var a = o;
        return r && (s.setAttribute("href", a), a = s.href), s.setAttribute("href", a), {
          href: s.href,
          protocol: s.protocol ? s.protocol.replace(/:$/, "") : "",
          host: s.host,
          search: s.search ? s.search.replace(/^\?/, "") : "",
          hash: s.hash ? s.hash.replace(/^#/, "") : "",
          hostname: s.hostname,
          port: s.port,
          pathname: s.pathname.charAt(0) === "/" ? s.pathname : "/" + s.pathname
        };
      }
      return i = n(window.location.href), function(a) {
        var c = e.isString(a) ? n(a) : a;
        return c.protocol === i.protocol && c.host === i.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    function() {
      return function() {
        return !0;
      };
    }()
  ), Se;
}
var ye, ot;
function at() {
  if (ot)
    return ye;
  ot = 1;
  var e = I, t = ws(), r = vs(), s = Nt, i = bs(), n = ks(), o = Es(), a = jt();
  return ye = function(u) {
    return new Promise(function(g, p) {
      var h = u.data, E = u.headers, m = u.responseType;
      e.isFormData(h) && delete E["Content-Type"];
      var d = new XMLHttpRequest();
      if (u.auth) {
        var k = u.auth.username || "", l = u.auth.password ? unescape(encodeURIComponent(u.auth.password)) : "";
        E.Authorization = "Basic " + btoa(k + ":" + l);
      }
      var f = i(u.baseURL, u.url);
      d.open(u.method.toUpperCase(), s(f, u.params, u.paramsSerializer), !0), d.timeout = u.timeout;
      function w() {
        if (d) {
          var y = "getAllResponseHeaders" in d ? n(d.getAllResponseHeaders()) : null, b = !m || m === "text" || m === "json" ? d.responseText : d.response, C = {
            data: b,
            status: d.status,
            statusText: d.statusText,
            headers: y,
            config: u,
            request: d
          };
          t(g, p, C), d = null;
        }
      }
      if ("onloadend" in d ? d.onloadend = w : d.onreadystatechange = function() {
        !d || d.readyState !== 4 || d.status === 0 && !(d.responseURL && d.responseURL.indexOf("file:") === 0) || setTimeout(w);
      }, d.onabort = function() {
        d && (p(a("Request aborted", u, "ECONNABORTED", d)), d = null);
      }, d.onerror = function() {
        p(a("Network Error", u, null, d)), d = null;
      }, d.ontimeout = function() {
        var b = "timeout of " + u.timeout + "ms exceeded";
        u.timeoutErrorMessage && (b = u.timeoutErrorMessage), p(a(
          b,
          u,
          u.transitional && u.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          d
        )), d = null;
      }, e.isStandardBrowserEnv()) {
        var S = (u.withCredentials || o(f)) && u.xsrfCookieName ? r.read(u.xsrfCookieName) : void 0;
        S && (E[u.xsrfHeaderName] = S);
      }
      "setRequestHeader" in d && e.forEach(E, function(b, C) {
        typeof h > "u" && C.toLowerCase() === "content-type" ? delete E[C] : d.setRequestHeader(C, b);
      }), e.isUndefined(u.withCredentials) || (d.withCredentials = !!u.withCredentials), m && m !== "json" && (d.responseType = u.responseType), typeof u.onDownloadProgress == "function" && d.addEventListener("progress", u.onDownloadProgress), typeof u.onUploadProgress == "function" && d.upload && d.upload.addEventListener("progress", u.onUploadProgress), u.cancelToken && u.cancelToken.promise.then(function(b) {
        d && (d.abort(), p(b), d = null);
      }), h || (h = null), d.send(h);
    });
  }, ye;
}
var T = I, ct = ms, Cs = Mt, xs = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function ut(e, t) {
  !T.isUndefined(e) && T.isUndefined(e["Content-Type"]) && (e["Content-Type"] = t);
}
function Ts() {
  var e;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (e = at()), e;
}
function Rs(e, t, r) {
  if (T.isString(e))
    try {
      return (t || JSON.parse)(e), T.trim(e);
    } catch (s) {
      if (s.name !== "SyntaxError")
        throw s;
    }
  return (r || JSON.stringify)(e);
}
var oe = {
  transitional: {
    silentJSONParsing: !0,
    forcedJSONParsing: !0,
    clarifyTimeoutError: !1
  },
  adapter: Ts(),
  transformRequest: [function(t, r) {
    return ct(r, "Accept"), ct(r, "Content-Type"), T.isFormData(t) || T.isArrayBuffer(t) || T.isBuffer(t) || T.isStream(t) || T.isFile(t) || T.isBlob(t) ? t : T.isArrayBufferView(t) ? t.buffer : T.isURLSearchParams(t) ? (ut(r, "application/x-www-form-urlencoded;charset=utf-8"), t.toString()) : T.isObject(t) || r && r["Content-Type"] === "application/json" ? (ut(r, "application/json"), Rs(t)) : t;
  }],
  transformResponse: [function(t) {
    var r = this.transitional, s = r && r.silentJSONParsing, i = r && r.forcedJSONParsing, n = !s && this.responseType === "json";
    if (n || i && T.isString(t) && t.length)
      try {
        return JSON.parse(t);
      } catch (o) {
        if (n)
          throw o.name === "SyntaxError" ? Cs(o, this, "E_JSON_PARSE") : o;
      }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  }
};
oe.headers = {
  common: {
    Accept: "application/json, text/plain, */*"
  }
};
T.forEach(["delete", "get", "head"], function(t) {
  oe.headers[t] = {};
});
T.forEach(["post", "put", "patch"], function(t) {
  oe.headers[t] = T.merge(xs);
});
var Le = oe, Is = I, As = Le, Ps = function(t, r, s) {
  var i = this || As;
  return Is.forEach(s, function(o) {
    t = o.call(i, t, r);
  }), t;
}, be, lt;
function Ht() {
  return lt || (lt = 1, be = function(t) {
    return !!(t && t.__CANCEL__);
  }), be;
}
var dt = I, ke = Ps, Us = Ht(), Os = Le;
function Ee(e) {
  e.cancelToken && e.cancelToken.throwIfRequested();
}
var qs = function(t) {
  Ee(t), t.headers = t.headers || {}, t.data = ke.call(
    t,
    t.data,
    t.headers,
    t.transformRequest
  ), t.headers = dt.merge(
    t.headers.common || {},
    t.headers[t.method] || {},
    t.headers
  ), dt.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(i) {
      delete t.headers[i];
    }
  );
  var r = t.adapter || Os.adapter;
  return r(t).then(function(i) {
    return Ee(t), i.data = ke.call(
      t,
      i.data,
      i.headers,
      t.transformResponse
    ), i;
  }, function(i) {
    return Us(i) || (Ee(t), i && i.response && (i.response.data = ke.call(
      t,
      i.response.data,
      i.response.headers,
      t.transformResponse
    ))), Promise.reject(i);
  });
}, R = I, Bt = function(t, r) {
  r = r || {};
  var s = {}, i = ["url", "method", "data"], n = ["headers", "auth", "proxy", "params"], o = [
    "baseURL",
    "transformRequest",
    "transformResponse",
    "paramsSerializer",
    "timeout",
    "timeoutMessage",
    "withCredentials",
    "adapter",
    "responseType",
    "xsrfCookieName",
    "xsrfHeaderName",
    "onUploadProgress",
    "onDownloadProgress",
    "decompress",
    "maxContentLength",
    "maxBodyLength",
    "maxRedirects",
    "transport",
    "httpAgent",
    "httpsAgent",
    "cancelToken",
    "socketPath",
    "responseEncoding"
  ], a = ["validateStatus"];
  function c(p, h) {
    return R.isPlainObject(p) && R.isPlainObject(h) ? R.merge(p, h) : R.isPlainObject(h) ? R.merge({}, h) : R.isArray(h) ? h.slice() : h;
  }
  function u(p) {
    R.isUndefined(r[p]) ? R.isUndefined(t[p]) || (s[p] = c(void 0, t[p])) : s[p] = c(t[p], r[p]);
  }
  R.forEach(i, function(h) {
    R.isUndefined(r[h]) || (s[h] = c(void 0, r[h]));
  }), R.forEach(n, u), R.forEach(o, function(h) {
    R.isUndefined(r[h]) ? R.isUndefined(t[h]) || (s[h] = c(void 0, t[h])) : s[h] = c(void 0, r[h]);
  }), R.forEach(a, function(h) {
    h in r ? s[h] = c(t[h], r[h]) : h in t && (s[h] = c(void 0, t[h]));
  });
  var _ = i.concat(n).concat(o).concat(a), g = Object.keys(t).concat(Object.keys(r)).filter(function(h) {
    return _.indexOf(h) === -1;
  });
  return R.forEach(g, u), s;
};
const Ns = "axios", Ms = "0.21.4", js = "Promise based HTTP client for the browser and node.js", Hs = "index.js", Bs = {
  test: "grunt test",
  start: "node ./sandbox/server.js",
  build: "NODE_ENV=production grunt build",
  preversion: "npm test",
  version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
  postversion: "git push && git push --tags",
  examples: "node ./examples/server.js",
  coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
  fix: "eslint --fix lib/**/*.js"
}, Ds = {
  type: "git",
  url: "https://github.com/axios/axios.git"
}, $s = [
  "xhr",
  "http",
  "ajax",
  "promise",
  "node"
], Ls = "Matt Zabriskie", Fs = "MIT", Ws = {
  url: "https://github.com/axios/axios/issues"
}, zs = "https://axios-http.com", Js = {
  coveralls: "^3.0.0",
  "es6-promise": "^4.2.4",
  grunt: "^1.3.0",
  "grunt-banner": "^0.6.0",
  "grunt-cli": "^1.2.0",
  "grunt-contrib-clean": "^1.1.0",
  "grunt-contrib-watch": "^1.0.0",
  "grunt-eslint": "^23.0.0",
  "grunt-karma": "^4.0.0",
  "grunt-mocha-test": "^0.13.3",
  "grunt-ts": "^6.0.0-beta.19",
  "grunt-webpack": "^4.0.2",
  "istanbul-instrumenter-loader": "^1.0.0",
  "jasmine-core": "^2.4.1",
  karma: "^6.3.2",
  "karma-chrome-launcher": "^3.1.0",
  "karma-firefox-launcher": "^2.1.0",
  "karma-jasmine": "^1.1.1",
  "karma-jasmine-ajax": "^0.1.13",
  "karma-safari-launcher": "^1.0.0",
  "karma-sauce-launcher": "^4.3.6",
  "karma-sinon": "^1.0.5",
  "karma-sourcemap-loader": "^0.3.8",
  "karma-webpack": "^4.0.2",
  "load-grunt-tasks": "^3.5.2",
  minimist: "^1.2.0",
  mocha: "^8.2.1",
  sinon: "^4.5.0",
  "terser-webpack-plugin": "^4.2.3",
  typescript: "^4.0.5",
  "url-search-params": "^0.10.0",
  webpack: "^4.44.2",
  "webpack-dev-server": "^3.11.0"
}, Ks = {
  "./lib/adapters/http.js": "./lib/adapters/xhr.js"
}, Vs = "dist/axios.min.js", Xs = "dist/axios.min.js", Gs = "./index.d.ts", Ys = {
  "follow-redirects": "^1.14.0"
}, Qs = [
  {
    path: "./dist/axios.min.js",
    threshold: "5kB"
  }
], Zs = {
  name: Ns,
  version: Ms,
  description: js,
  main: Hs,
  scripts: Bs,
  repository: Ds,
  keywords: $s,
  author: Ls,
  license: Fs,
  bugs: Ws,
  homepage: zs,
  devDependencies: Js,
  browser: Ks,
  jsdelivr: Vs,
  unpkg: Xs,
  typings: Gs,
  dependencies: Ys,
  bundlesize: Qs
};
var Dt = Zs, Fe = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(e, t) {
  Fe[e] = function(s) {
    return typeof s === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
var ht = {}, ei = Dt.version.split(".");
function $t(e, t) {
  for (var r = t ? t.split(".") : ei, s = e.split("."), i = 0; i < 3; i++) {
    if (r[i] > s[i])
      return !0;
    if (r[i] < s[i])
      return !1;
  }
  return !1;
}
Fe.transitional = function(t, r, s) {
  var i = r && $t(r);
  function n(o, a) {
    return "[Axios v" + Dt.version + "] Transitional option '" + o + "'" + a + (s ? ". " + s : "");
  }
  return function(o, a, c) {
    if (t === !1)
      throw new Error(n(a, " has been removed in " + r));
    return i && !ht[a] && (ht[a] = !0, console.warn(
      n(
        a,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(o, a, c) : !0;
  };
};
function ti(e, t, r) {
  if (typeof e != "object")
    throw new TypeError("options must be an object");
  for (var s = Object.keys(e), i = s.length; i-- > 0; ) {
    var n = s[i], o = t[n];
    if (o) {
      var a = e[n], c = a === void 0 || o(a, n, e);
      if (c !== !0)
        throw new TypeError("option " + n + " must be " + c);
      continue;
    }
    if (r !== !0)
      throw Error("Unknown option " + n);
  }
}
var ri = {
  isOlderVersion: $t,
  assertOptions: ti,
  validators: Fe
}, Lt = I, si = Nt, gt = ps, ft = qs, ae = Bt, Ft = ri, V = Ft.validators;
function Q(e) {
  this.defaults = e, this.interceptors = {
    request: new gt(),
    response: new gt()
  };
}
Q.prototype.request = function(t) {
  typeof t == "string" ? (t = arguments[1] || {}, t.url = arguments[0]) : t = t || {}, t = ae(this.defaults, t), t.method ? t.method = t.method.toLowerCase() : this.defaults.method ? t.method = this.defaults.method.toLowerCase() : t.method = "get";
  var r = t.transitional;
  r !== void 0 && Ft.assertOptions(r, {
    silentJSONParsing: V.transitional(V.boolean, "1.0.0"),
    forcedJSONParsing: V.transitional(V.boolean, "1.0.0"),
    clarifyTimeoutError: V.transitional(V.boolean, "1.0.0")
  }, !1);
  var s = [], i = !0;
  this.interceptors.request.forEach(function(p) {
    typeof p.runWhen == "function" && p.runWhen(t) === !1 || (i = i && p.synchronous, s.unshift(p.fulfilled, p.rejected));
  });
  var n = [];
  this.interceptors.response.forEach(function(p) {
    n.push(p.fulfilled, p.rejected);
  });
  var o;
  if (!i) {
    var a = [ft, void 0];
    for (Array.prototype.unshift.apply(a, s), a = a.concat(n), o = Promise.resolve(t); a.length; )
      o = o.then(a.shift(), a.shift());
    return o;
  }
  for (var c = t; s.length; ) {
    var u = s.shift(), _ = s.shift();
    try {
      c = u(c);
    } catch (g) {
      _(g);
      break;
    }
  }
  try {
    o = ft(c);
  } catch (g) {
    return Promise.reject(g);
  }
  for (; n.length; )
    o = o.then(n.shift(), n.shift());
  return o;
};
Q.prototype.getUri = function(t) {
  return t = ae(this.defaults, t), si(t.url, t.params, t.paramsSerializer).replace(/^\?/, "");
};
Lt.forEach(["delete", "get", "head", "options"], function(t) {
  Q.prototype[t] = function(r, s) {
    return this.request(ae(s || {}, {
      method: t,
      url: r,
      data: (s || {}).data
    }));
  };
});
Lt.forEach(["post", "put", "patch"], function(t) {
  Q.prototype[t] = function(r, s, i) {
    return this.request(ae(i || {}, {
      method: t,
      url: r,
      data: s
    }));
  };
});
var ii = Q, Ce, pt;
function Wt() {
  if (pt)
    return Ce;
  pt = 1;
  function e(t) {
    this.message = t;
  }
  return e.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, e.prototype.__CANCEL__ = !0, Ce = e, Ce;
}
var xe, _t;
function ni() {
  if (_t)
    return xe;
  _t = 1;
  var e = Wt();
  function t(r) {
    if (typeof r != "function")
      throw new TypeError("executor must be a function.");
    var s;
    this.promise = new Promise(function(o) {
      s = o;
    });
    var i = this;
    r(function(o) {
      i.reason || (i.reason = new e(o), s(i.reason));
    });
  }
  return t.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, t.source = function() {
    var s, i = new t(function(o) {
      s = o;
    });
    return {
      token: i,
      cancel: s
    };
  }, xe = t, xe;
}
var Te, mt;
function oi() {
  return mt || (mt = 1, Te = function(t) {
    return function(s) {
      return t.apply(null, s);
    };
  }), Te;
}
var Re, wt;
function ai() {
  return wt || (wt = 1, Re = function(t) {
    return typeof t == "object" && t.isAxiosError === !0;
  }), Re;
}
var vt = I, ci = Ut, re = ii, ui = Bt, li = Le;
function zt(e) {
  var t = new re(e), r = ci(re.prototype.request, t);
  return vt.extend(r, re.prototype, t), vt.extend(r, t), r;
}
var U = zt(li);
U.Axios = re;
U.create = function(t) {
  return zt(ui(U.defaults, t));
};
U.Cancel = Wt();
U.CancelToken = ni();
U.isCancel = Ht();
U.all = function(t) {
  return Promise.all(t);
};
U.spread = oi();
U.isAxiosError = ai();
Be.exports = U;
Be.exports.default = U;
var di = Be.exports, hi = di;
const H = /* @__PURE__ */ Y(hi);
class gi {
  constructor(t) {
    B(this, "instance");
    B(this, "cache");
    B(this, "sessionStorage");
    this.cache = /* @__PURE__ */ new Map(), this.instance = t, this.sessionStorage = window.sessionStorage;
  }
  wrapCache(t, r, s, i = {}, n) {
    const o = this.generateCacheKey(t, r, s, i);
    if (!i.refreshCache) {
      const c = this.retrieveFromMemoryCache(o);
      if (c)
        return c;
    }
    const a = n();
    return this.storeInMemoryCache(a, o, Date.now() + 1e3 * (i.cacheTimeout || 5) * 60), a;
  }
  wrapSessionCache(t, r, s, i = {}, n) {
    const o = this.generateCacheKey(t, r, s, i);
    if (!i.refreshCache) {
      const u = this.retrieveFromMemoryCache(o);
      if (u)
        return u;
      {
        const _ = this.retrieveFromSessionCache(o);
        if (_)
          return _;
      }
    }
    const a = Date.now() + 1e3 * (i.cacheTimeout || 5) * 60, c = n();
    return this.storeInMemoryCache(c, o, a), this.storeInSessionCache(c, o, a), c;
  }
  storeInMemoryCache(t, r, s) {
    this.cache.set(r, {
      promise: t,
      endTime: s
    });
  }
  retrieveFromMemoryCache(t) {
    const r = this.cache.get(t);
    return r && r.endTime >= Date.now() ? r.promise : null;
  }
  storeInSessionCache(t, r, s) {
    t.then((i) => {
      this.sessionStorage.setItem(r, JSON.stringify({
        response: i,
        endTime: s
      }));
    }).catch((i) => {
      console.error(i);
    });
  }
  retrieveFromSessionCache(t) {
    const r = JSON.parse(this.sessionStorage.getItem(t) || "null");
    if (r && r.endTime >= Date.now()) {
      const s = Promise.resolve(r.response);
      return this.storeInMemoryCache(s, t, r.endTime), s;
    } else
      return null;
  }
  generateCacheKey(t, r, s, i = {}) {
    return JSON.stringify({
      url: r,
      params: i.params,
      data: s || i.data,
      method: t
    });
  }
  wrapPromise(t, r) {
    return t.cancelToken = r, t.cancel = function(s = "Operation canceled by the user.") {
      this.cancelToken.cancel(s);
    }, t;
  }
  request(t) {
    const r = H.CancelToken.source();
    return t.cancelToken = r.token, this.wrapPromise(this.instance.request(t), r);
  }
  getCached(t, r = {}) {
    return this.wrapCache("get", t, void 0, r, () => this.instance.get(t, r));
  }
  getSessionCached(t, r = {}) {
    return this.wrapSessionCache(
      "get",
      t,
      void 0,
      r,
      () => this.instance.get(t, r)
    );
  }
  get(t, r = {}) {
    const s = H.CancelToken.source();
    return r.cancelToken = s.token, this.wrapPromise(this.instance.get(t, r), s);
  }
  delete(t, r = {}) {
    const s = H.CancelToken.source();
    return r.cancelToken = s.token, this.wrapPromise(this.instance.delete(t, r), s);
  }
  head(t, r = {}) {
    const s = H.CancelToken.source();
    return r.cancelToken = s.token, this.wrapPromise(this.instance.head(t, r), s);
  }
  postCached(t, r, s = {}) {
    return this.wrapCache("post", t, r, s, () => this.instance.post(t, r, s));
  }
  postSessionCached(t, r, s = {}) {
    return this.wrapSessionCache(
      "post",
      t,
      r,
      s,
      () => this.instance.post(t, r, s)
    );
  }
  post(t, r, s = {}) {
    const i = H.CancelToken.source();
    return s.cancelToken = i.token, this.wrapPromise(this.instance.post(t, r, s), i);
  }
  patch(t, r, s = {}) {
    const i = H.CancelToken.source();
    return s.cancelToken = i.token, this.wrapPromise(this.instance.patch(t, r, s), i);
  }
  put(t, r, s = {}) {
    const i = H.CancelToken.source();
    return s.cancelToken = i.token, this.wrapPromise(this.instance.put(t, r, s), i);
  }
  evictAllCache() {
    this.cache = /* @__PURE__ */ new Map();
  }
}
function Jt(e, t, r) {
  const s = H.create();
  return s.defaults.timeout = 6e5, s.interceptors.request.use(function(i) {
    return i.headers.common.Accept = "application/json,application/problem+json", i.headers.common["X-Client-Id"] = {}.VITE_MODE === "public" ? "public-service-portal" : "internal-service-portal", i.url = e + i.url, i;
  }), s.interceptors.request.use(async function(i) {
    try {
      const n = await window.auth.getUser();
      return n != null && n.access_token && (i.headers.Authorization = "Bearer " + n.access_token), i;
    } catch (n) {
      throw new H.Cancel("An error occurred while getting the access token" + (n && n.message ? " :" + n.message : ""));
    }
  }), t && s.interceptors.response.use(function(i) {
    if (i.data !== "" && typeof i.data == "string")
      throw new Error("API responses should have valid json content");
    return i;
  }), r && s.interceptors.response.use(r), s.interceptors.response.use(void 0, (i) => {
    throw i && i.response && i.response.status === 401 ? new Error("unauthorized") : i;
  }), new gi(s);
}
function xi(e, t, r) {
  return Jt(window.env.API_BASE + e, t, r);
}
function Ti(e, t, r) {
  return Jt(e, t, r);
}
export {
  Ge as Auth,
  D as Constants,
  ir as Environment,
  Qt as Language,
  Zt as Languages,
  nr as SortDirection,
  Yt as UserRealms,
  St as UserRoles,
  Gt as UserRolesDescription,
  Si as allowedUserRoles,
  xi as configureForApi,
  Ti as configureForApiCustom,
  We as deepClone,
  Ei as env,
  vi as hasAllRoles,
  wi as hasOneOfRoles,
  er as isPlainObject,
  Ci as paginationQueryUrl,
  _i as parseErrorMessage,
  mi as parseProblemErrorMessage,
  ki as reversedDashedDate,
  yi as similarity,
  bi as toUTCDate
};
//# sourceMappingURL=commons.js.map
